export const ES_NAME = 'ES';

export const ES_TRANS = {
  // UPS Service Types
  '01' : 'UPS Next Day Air',
  '01S': 'UPS Next Day Air (Saturday)',
  '02' : 'UPS 2nd Day Air',
  '02S': 'UPS 2nd Day Air (Saturday)',
  '03' : 'UPS Ground',
  '07' : 'UPS Standard',
  '08' : 'UPS Worldwide Expedited',
  '11' : 'UPS Worldwide Express',
  '12' : 'UPS 3 Day Select',
  '13' : 'UPS Next Day Air Saver',
  '14' : 'UPS Next Day Air Early',
  '14S': 'UPS Next Day Air Early (Saturday)',
  '54' : 'UPS Worldwide Express Plus',
  '59' : 'UPS 2nd Day Air A.M.®',
  '65' : 'UPS Worldwide Saver',
  'M4' : 'UPS Mail Innovations',

  '22FOR2_INSTRUCTIONS' : 'Coloque los stickers dentro del sobre y coloque la etiqueta de dirección y la etiqueta de Avery en el exterior del sobre.',
  '22FOR2_PACKING_INSTRUCTIONS' : 'Favor de empacar orden sin Packing List (Ficha de Embalaje).',

  'UPS_01'     : 'UPS Next Day Air',
  'UPS_01S'    : 'UPS Next Day Air (Saturday)',
  'UPS_02'     : 'UPS 2nd Day Air',
  'UPS_02S'    : 'UPS 2nd Day Air (Saturday)',
  'UPS_03'     : 'UPS Ground',
  'UPS_07'     : 'UPS Worldwide Express',
  'UPS_08'     : 'UPS Worldwide Expedited',
  'UPS_11'     : 'UPS Standard',
  'UPS_12'     : 'UPS 3 Day Select',
  'UPS_13'     : 'UPS Next Day Air Saver',
  'UPS_14'     : 'UPS Next Day Air Early',
  'UPS_14S'    : 'UPS Next Day Air Early (Saturday)',
  'UPS_54'     : 'UPS Worldwide Express Plus',
  'UPS_59'     : 'UPS 2nd Day Air A.M.®',
  'UPS_65'     : 'UPS Worldwide Saver',
  'USPS_0_FCLE': 'UPS Mail Innovations',
  'USPS_0_FCL' : 'UPS Mail Innovations',
  'USPS_0_FCP' : 'UPS Mail Innovations',
  'USPS_0_FCPC': 'UPS Mail Innovations',
  'USPS_1'     : 'UPS Mail Innovations',
  'USPS_2'     : 'UPS Mail Innovations',
  'USPS_3'     : 'UPS Mail Innovations',
  'USPS_4'     : 'UPS Mail Innovations',
  'USPS_5'     : 'UPS Mail Innovations',
  'USPS_6'     : 'UPS Mail Innovations',
  'USPS_13'    : 'UPS Mail Innovations',
  'USPS_15'    : 'UPS Mail Innovations',
  'USPS_16'    : 'UPS Mail Innovations',
  'USPS_17'    : 'UPS Mail Innovations',
  'USPS_22'    : 'UPS Mail Innovations',
  'USPS_23'    : 'UPS Mail Innovations',
  'USPS_25'    : 'UPS Mail Innovations',
  'USPS_27'    : 'UPS Mail Innovations',
  'USPS_28'    : 'UPS Mail Innovations',
  'USPS_29'    : 'UPS Mail Innovations',
  'USPS_30'    : 'UPS Mail Innovations',
  'USPS_31'    : 'UPS Mail Innovations',
  'USPS_32'    : 'UPS Mail Innovations',
  'USPS_33'    : 'UPS Mail Innovations',
  'USPS_34'    : 'UPS Mail Innovations',
  'USPS_35'    : 'UPS Mail Innovations',
  'USPS_36'    : 'UPS Mail Innovations',
  'USPS_37'    : 'UPS Mail Innovations',
  'USPS_38'    : 'UPS Mail Innovations',
  'USPS_39'    : 'UPS Mail Innovations',
  'USPS_40'    : 'UPS Mail Innovations',
  'USPS_41'    : 'UPS Mail Innovations',
  'USPS_42'    : 'UPS Mail Innovations',
  'USPS_43'    : 'UPS Mail Innovations',
  'USPS_44'    : 'UPS Mail Innovations',
  'USPS_45'    : 'UPS Mail Innovations',
  'USPS_46'    : 'UPS Mail Innovations',
  'USPS_47'    : 'UPS Mail Innovations',
  'USPS_48'    : 'UPS Mail Innovations',
  'USPS_49'    : 'UPS Mail Innovations',
  'USPS_50'    : 'UPS Mail Innovations',
  'USPS_53'    : 'UPS Mail Innovations',
  'USPS_55'    : 'UPS Mail Innovations',
  'USPS_56'    : 'UPS Mail Innovations',
  'USPS_57'    : 'UPS Mail Innovations',
  'USPS_58'    : 'UPS Mail Innovations',
  'USPS_59'    : 'UPS Mail Innovations',
  'USPS_61'    : 'UPS Mail Innovations',
  'USPS_62'    : 'UPS Mail Innovations',
  'USPS_63'    : 'UPS Mail Innovations',
  'USPS_64'    : 'UPS Mail Innovations',
  'USPS_INT_1' : 'UPS Mail Innovations',
  'USPS_INT_2' : 'UPS Mail Innovations',
  'USPS_INT_4' : 'UPS Mail Innovations',
  'USPS_INT_5' : 'UPS Mail Innovations',
  'USPS_INT_6' : 'UPS Mail Innovations',
  'USPS_INT_7' : 'UPS Mail Innovations',
  'USPS_INT_8' : 'UPS Mail Innovations',
  'USPS_INT_9' : 'UPS Mail Innovations',
  'USPS_INT_10': 'UPS Mail Innovations',
  'USPS_INT_11': 'UPS Mail Innovations',
  'USPS_INT_12': 'UPS Mail Innovations',
  'USPS_INT_13': 'UPS Mail Innovations',
  'USPS_INT_14': 'UPS Mail Innovations',
  'USPS_INT_15': 'UPS Mail Innovations',
  'USPS_INT_16': 'UPS Mail Innovations',
  'USPS_INT_17': 'UPS Mail Innovations',
  'USPS_INT_18': 'UPS Mail Innovations',
  'USPS_INT_19': 'UPS Mail Innovations',
  'USPS_INT_20': 'UPS Mail Innovations',
  'USPS_INT_21': 'UPS Mail Innovations',
  'USPS_INT_22': 'UPS Mail Innovations',
  'USPS_INT_23': 'UPS Mail Innovations',
  'USPS_INT_24': 'UPS Mail Innovations',
  'USPS_INT_25': 'UPS Mail Innovations',
  'USPS_INT_26': 'UPS Mail Innovations',
  'USPS_INT_27': 'UPS Mail Innovations',
  // FedEx
  'FEDEX_INTERNATIONAL_PRIORITY_EXPRESS': 'FedEx International Priority® Express',
  'INTERNATIONAL_FIRST'                 : 'FedEx International First®',
  'FEDEX_INTERNATIONAL_PRIORITY'        : 'FedEx International Priority®',
  'INTERNATIONAL_ECONOMY'               : 'FedEx International Economy®',
  'FEDEX_GROUND'                        : 'FedEx International Ground® y FedEx Domestic Ground®',
  'FEDEX_CARGO_INTERNATIONAL_PREMIUM'   : 'FedEx International Premium®',
  'FIRST_OVERNIGHT'                     : 'FedEx First Overnight®',
  'FEDEX_FIRST_FREIGHT'                 : 'FedEx First Overnight® Freight',
  'FEDEX_1_DAY_FREIGHT'                 : 'FedEx 1Day® Freight (El servicio a Hawaii es solo desde y hacia la isla de Oahu)',
  'FEDEX_2_DAY_FREIGHT'                 : 'FedEx 2Day® Freight (El servicio a Hawaii es solo desde y hacia la isla de Oahu)',
  'FEDEX_3_DAY_FREIGHT'                 : 'FedEx 3Day® Freight (Excepto Alaska y Hawaii)',
  'INTERNATIONAL_PRIORITY_FREIGHT'      : 'FedEx International Priority® Freight',
  'INTERNATIONAL_ECONOMY_FREIGHT'       : 'FedEx International Economy® Freight',
  'FEDEX_CARGO_AIRPORT_TO_AIRPORT'      : 'FedEx International Express Freight® y FedEx International Airport-to-AirportSM',
  'INTERNATIONAL_PRIORITY_DISTRIBUTION' : 'FedEx International Priority DirectDistribution®',
  'FEDEX_IP_DIRECT_DISTRIBUTION_FREIGHT': 'FedEx International Priority DirectDistribution® Freight',
  'INTL_GROUND_DISTRIBUTION'            : 'International Ground® Distribution (IGD)',
  'GROUND_HOME_DELIVERY'                : 'FedEx Home Delivery',
  'SMART_POST'                          : 'FedEx Ground® Economy (anteriormente conocido como FedEx SmartPost®)',
  'PRIORITY_OVERNIGHT'                  : 'FedEx Priority Overnight®',
  'STANDARD_OVERNIGHT'                  : 'FedEx Standard Overnight® (solo para envíos salientes de Hawaii)',
  'FEDEX_2_DAY'                         : 'FedEx 2Day® (Excepto Intra-Hawaii)',
  'FEDEX_2_DAY_AM'                      : 'FedEx 2Day® AM (solo para envíos salientes de Hawaii)',
  'FEDEX_EXPRESS_SAVER'                 : 'FedEx Express Saver® (Excepto Alaska y Hawaii)',
  'SAME_DAY'                            : 'FedEx SameDay®',
  'SAME_DAY_CITY'                       : 'FedEx SameDay® City (Áreas metropolitanas seleccionadas de EE.UU.)',
  'FIRST_OVERNIGHT_SATURDAY'            : 'FedEx First Overnight® (Sábado)',
  'PRIORITY_OVERNIGHT_SATURDAY'         : 'FedEx Priority Overnight® (Sábado)',
  'STANDARD_OVERNIGHT_SATURDAY'         : 'FedEx Standard Overnight® (Sábado)',
  'FEDEX_2_DAY_SATURDAY'                : 'FedEx 2Day® (Sábado)',
  'FEDEX_2_DAY_AM_SATURDAY'             : 'FedEx 2Day® AM (Sábado - solo para envíos salientes de Hawaii)',
  // FedEx Address Validation Response Code
  // 'STANDARDIZED.ADDRESS.NOTFOUND' : 'Address Not Found',
  'INVALID_SUITE_NUMBER' : 'Apartamento/Suite no válido o inexistente',
  'SUITE_NUMBER_REQUIRED' : 'Apartamento/Suite no válido o inexistente',
  'PARTIAL_STREET_MATCH' : 'Se requiere una dirección para la entrega. La dirección introducida es un intervalo de números de calles',
  'MISSING_OR_AMBIGUOUS_DIRECTIONAL' : 'Dirección direccional no válida o que falta',
  'INTERPOLATED_STREET_ADDRESS' : 'No se ha podido confirmar el número exacto de la calle introducido. La dirección se encuentra dentro de un rango válido para el nombre de la calle.',
  'RRHC_CONVERSIO' : 'Se requiere una dirección para la entrega. La dirección ha sido convertida desde una ruta rural.',

  // Product Materials
  'CARDSTOCK'         : 'Card Stock',
  'CLEARFILM'         : 'Clear Film',
  'WHITEFILM'         : 'White Film',
  'SILVERFILM'        : 'Silver Film',
  'KRAFTPAPER'        : 'Kraft Paper',
  'MATTEPAPER'        : 'Matte Paper',
  'WHITEMATTEPAPER'   : 'White Matte Paper',
  'ADHESIVENAMEBADGES': 'Adhesive Name Badges',
  'BUMPERSTICKERFILM' : 'Bumper Sticker Film',
  ACCESSORY : {
    CHECK_FOR_ORDER : 'Comprobación accesorio para Orden',
    OK            : 'Accessory OK',
    ADD           : 'Add Accesorio',
    CHECK         : 'Accessory Check',
    CHECK_JOB     : 'Compruebe los accesorios de cada trabajo y asegúrese de que el tipo y la cantidad de accesorios son correctos',
    MISSING       : 'Accesorio Faltante',
    HOLD_PROMPT   : 'Seleccione los accessorio con problemas de calidad y añada un motivo de retención (requerido): ',
    NOT_OKAY_HOLD : 'Accessorio No OK / Poner en Hold',
    SCAN_ERROR_TITLE : 'Error de escaneado de accesorio',
    SCAN_ERROR_BODY : 'Por favor, asegúrese de que el accesorio escaneado es correcto en cantidad y tipo',
  },
  ACCOUNT_CREATE_SUCCESS  : 'Cuenta creada con éxito',
  ACCOUNT_CREATE_ERROR    : 'Error al crear la cuenta',
  ACCOUNT_CREATE_INFO     : 'Su cuenta (%0) todavía debe ser verificada. Por favor, comprueba tu correo electrónico.',
  ACCOUNT_CREATE_ERROR_INFO : 'El usuario ya existe. (%0)',
  ACCOUNT_VALIDATION_INFO: {
    MIN_LENGTH: 'Mínimo %0 caracteres',
    UPPER_CASE: 'Al menos una letra mayúscula',
    LOWER_CASE: 'Al menos una letra minúscula',
    NUMBER: 'Al menos un número',
    SPECIAL_CHAR: 'Al menos un carácter especial',
    EMAIL_AVERY_REQUIRED: 'El registro solo está permitido con direcciones de correo electrónico @avery.com',
    PASSWORD_SECURITY_REQUIREMENTS: 'La contraseña no cumple con los requisitos de seguridad'
  },
  ACTIONS                 : 'Acciones',
  ACTIVE                  : 'Activo',
  ACTIVE_JOBS             : 'Trabajos activos',
  ACTIVE_WORK             : 'Trabajo Activo',
  ADD                     : 'Añadir',
  ADD_NEW_CONFIG          : 'Añadir nueva configuración',
  ADD_BATCHES             : 'Añadir batches',
  ADD_BATCHES_CONFIRM     : '¿Está seguro de que desea crear nuevos batches? Este proceso es irreversible.',
  ADD_BOX                 : 'Añadir Caja',
  ADD_EMPLOYEE            : 'Add Employee',
  ADD_QR_CODE             : 'Añadir código QR y cambiar a corte por láser',
  ADD_SCRAP               : 'Añadir %0 hojas a la chatarra',
  ADD_TO_EOD              : 'Add to EoD',
  ADDRESS                 : 'Dirección',
  ADDRESS1                : 'Address 1',
  ADDRESS1_REQUIRED       : 'Se requiere la dirección 1',
  ADDRESS1_TOO_LONG       : 'La dirección 1 no puede exceder los 35 caracteres',
  ADDRESS2                : 'Address 2',
  ADDRESS2_TOO_LONG       : 'La dirección 2 no puede exceder los 35 caracteres',
  ADDRESS3                : 'Address 3',
  ADDRESS3_TOO_LONG       : 'La dirección 3 no puede exceder los 35 caracteres',
  ADDRESS_AMBIGUOUS       : 'La dirección proporcionada no se encontró. Querías decir:',
  ADDRESS_NOT_FOUND       : 'La dirección proporcionada no se encontró.',
  ADDRESS_VALID           : 'La dirección es válida!',
  ADDRESS_VALIDATION      : 'Validación de domicilio',
  ADDRESS_VALIDATED_UPS   : 'Validado por UPS',
  ADDRESS_VALIDATED_FEDEX : 'Validado por FEDEX',
  ADDRESS_NOT_VALID       : 'Domicilio no válido',
  ADDRESS_INVALID         : 'Domicilio no válido',
  ADDRESS_LABEL           : 'Etiqueta De Dirección',
  ADJUST_DIE_PRESSURE     : 'Ajustar la presion de la navaja',
  ADMIN                   : 'Administración',
  ADMIN_CENTER            : 'Centro de administración',
  ADMIN_VERIFIED          : 'Admin Verificado',
  ACTIVATE_DIE_MATERIAL   : 'Por favor, habilite la %0 para liberar el Trabajo de la espera.',
  ALL                     : 'Todos',
  ALLOW_PARTIAL_REPRINT   : 'Permitir Reprint Parcial',
  ALL_BATCHES             : 'Todos los batches',
  ALL_FIELDS_REQUIRED     : 'Todos los campos son obligatorios',
  ALL_FIELDS_REQUIRED_INFO: 'Por favor complete todos los campos %0.',
  ALL_JOBS                : 'Todos los trabajos',
  ALL_ORDERS              : 'Todos los pedidos',
  ALL_SHIPMENTS           : 'Todos los envíos',
  ALREADY_HAVE_ACCOUNT    : '¿Ya tiene una cuenta?',
  ARE_YOU_SURE_TO_UPDATE  : 'Are you sure to update?',
  ARTWORK_ERROR           : 'Error en arte',
  ARTWORK_IDENTIFIER      : 'Identificador de la obra de arte',
  APPLY                   : 'Aplicar',
  ARTWORK_SCALE_FACTOR    : 'Factor Escala de Arte',
  ARTWORK_STATUS          : 'Estado del Arte',
  AMAZON                  : 'Amazon',
  AMAZON_ORDERS           : 'Pedidos de Amazon',
  AMOUNT                  : 'Importe',
  AMAZON_MULTIBOX       : {
    HEADER       : 'Amazon Multi Box',
    WAITING      : 'Favor de esperar mientras se obtiene Etiqueta de Multi Caja',
    ERROR        : 'Favor de notificar a Coordinador/Supervisor problema con envío.'
  },
  APPROVE                 : 'Approve',
  APPROVE_ALL             : 'Approve All',
  APPROVED                : 'Approved',
  APPROVAL_REQUIRED       : {
    APPROVAL_REQUIRED                    : 'Aprobación Requerida',
    APPROVAL_REQUIRED_HEADER             : 'Aprobación Requerida Para Proceder',
    APPROVAL_REQUIRED_LOGIN              : 'Iniciar Sesión (Supervisor)',
    APPROVAL_REQUIRED_SIGNIN_DESCRIPTION1: 'Nota: acción debe ser revisada y aprobada por un supervisor.',
    APPROVAL_REQUIRED_SIGNIN_DESCRIPTION2: 'Requerimiento: Por favor, contacte a un supervisor para aprobar la acción iniciando sesión',
    APPROVAL_REQUIRED_INVALID            : 'El usuario no es administrador / Nombre de usuario o contraseña inválidos',
  },
  ATTENTION_REQUIRED      : 'Atención Requerida',
  ATTRIBUTES              : 'Atributos',
  AVAILABLE_DIES          : 'Dados disponibles',
  AVAILABLE_HORIZONS      : 'Available Horizons',
  AVAILABLE_PRINTERS      : 'Impresoras disponibles',
  BACK                    : 'Reverso',
  BACK_TO_BATCHES         : 'Reverso a la lista de batches',
  BACK_TO_PROFILE         : 'Reverso al Perfil',
  BACK_TO_JOBS            : 'Reverso a la lista de trabajos',
  BACK_TO_SHIPMENTS       : 'Reverso a la lista de envíos',
  BARCODE                 : 'Código de barras',
  BATCH                   : 'Batch',
  BATCH_CREATED           : 'Nuevo batch creado',
  BATCH_CREATED_INFO      : 'Se ha creado el batch "%0"!',
  BATCH_CUTTING           : 'Corte por batches',
  BATCH_DELETED           : 'Batch borrado',
  BATCH_DELETED_INFO      : 'Se ha eliminado el batch "%0"!',
  BATCH_DETAILS           : 'Detalles del batch',
  BATCH_ID                : 'Batch ID',
  BATCH_INFO              : 'Información de batch',
  BATCH_LIST              : 'Lista de Batches',
  BATCH_NOT_FOUND         : '¡Oops! No se ha encontrado el batch "%0".',
  BATCH_STATUS            : 'Estatus del batch',
  BATCH_UPDATED           : 'Batch actualizado',
  BATCH_UPDATED_INFO      : 'El batch "%0" ha sido actualizado',
  BATCHED                 : 'Batched',
  BATCHES                 : 'Batches',
  BATCHES_NOT_FOUND       : 'Este batch no está asociado actualmente a ningún trabajo.',
  BCB_PADDING             : 'Business Card Book Padding',
  BEGIN_CUTTING           : 'Comenzar a corte',
  BEGIN_LAMINATING        : 'Comenzar a laminar',
  BIN                     : 'Bin',
  BIN_MANAGER             : 'Administrador de Bin',
  BIN_UPDATED             : 'Bin actualizado',
  BIN_UPDATED_INFO        : 'Bin "%0" ha sido actualizado.',
  BINS                    : 'Bins',
  BINS_FULL               : ' Bins lleno',
  BIN_FULL_BODY           : 'Todos los contenedores están llenos. El trabajo ha vuelto a su estado anterior.',
  BINNED                  : 'Envasado',
  BOTTOM                  : 'Fondo',
  BOXED                   : 'Boxed',
  BOX_ADDED               : 'Caja añadida',
  BOX_REMOVED             : 'Caja extraída',
  BREAKS                  : 'Breaks',
  BUSINESS_UNIT           : 'Business Unit',
  BOTH_SIDES              : 'Ambos lados',
  CARDS                   : 'Tarjetas',
  CAM                     : 'Cam',
  CAM_STATUS              : 'Cam Status',
  CANCEL                  : 'Cancelar',
  CANCEL_ORDER            : 'Cancelar Orden',
  CANCEL_ORDER_CONFIRM    : '¿Estás seguro de que quieres cancelar esta orden?',
  CANCELLED               : 'Cancelado',
  CAPACITY                : 'Capacity',
  CAPACITY_CONFIG         : 'Capacity Configuration',
  CAPACITY_SETT           : {
    CURRENT_LOAD                    : 'Current Load',
    CURRENT_CAPACITY                : 'Current Capacity',
    HOURLY_CAPACITY                 : 'Hourly Capacity',
    HOURLY_AVG_CAPACITY             : 'Hourly Avg. Capacity',
    HOURLY_MAX_CAPACITY             : 'Hourly Max Capacity',
    DAILY_CAPACITY                  : 'Daily Capacity',
    DAILY_MAX_CAPACITY              : 'Daily Max Capacity',
    OPERATOR_HOURLY_AVG_CAPACITY    : 'Operator Hourly Avg. Capacity',
    OPERATOR_WORKING_HR_PER_DAY     : 'Operator Working Hours Per Day',
    WORKING_HR_PER_DAY              : 'Working Hours Per Day',
    SETUP_HOUR                      : 'Set-up Hours',
    SETUP_QTY                       : 'Set-up Qty',
    METRIC_SETTINGS                 : 'Metric Settings',
    LOAD_CAPACITY_SETTINGS          : 'Load & Capacity Settings',
    PERCENTAGE_WORKING              : 'Percentage of Working Process',
    LOAD_CAPACITY                   : 'Machine Capacity and Load Settings',
    METRIC_UPDATE_MSG               : 'The metric values are updated',
  },
  CARRIER                 : 'Transportista',
  CARRIER_FILTER          : 'Filtro de Transportista',
  CATEGORY                : 'Categoría',
  CELLS                   : 'Células',
  CHANGE_CUT_MACHINE      : 'Cambiar Maq. de Cort',
  CHANGE_CUT_MACHINE_SELECT: 'Seleccionar Máquina de Corte: ',
  CHANGE_CUT_MACHINE_ORDERS  : 'Change Cut Machine for Jobs',
  CHANGE_CUT_MACHINE_CUSTOM_SIZE_NO_CHANGE : 'Custom Size jobs will not be changed',
  CHANGE_CUT_MACHINE_HELP: {
    TITLE: 'Para cambiar la máquina de corte, por favor:',
    STEP1: 'Seleccione la máquina objetivo a la que desea mover los trabajos',
    STEP2: 'Seleccione o busque trabajos de la lista inferior',
    STEP3: 'Haga clic en el botón "Mover Trabajos" para completar el cambio',
  },
  CHANGE_INCLUDES_WHITE_INK: 'El cambio incluye tinta blanca',
  CHANGE_PREFERRED_CUTTING : 'Cambiar corte preferido',
  CHANGE_HORIZON           : 'Cambiar Horizonte',
  CHANGE_HORIZON_DESC      : 'Cambiar el horizonte del batch',
  CHANGE_LASER             : 'Cambiar láser',
  CHANGE_LASER_DESC        : 'Por favor, seleccione el láser al que desea cambiar el batch.',
  CHANGE_HOLD_REASON      : 'Modificar Motivo de Retención',
  CHANGE_HOLD_REASON_CONFIRM: 'Por favor, introduzca un nuevo motivo de retención para este %0',
  CHANGE_PASSWORD         : 'Cambiar contraseña',
  CHANGE_PASSWORD_HELP    : 'Establecer una nueva contraseña. Tenga en cuenta que tendrá que iniciar sesión de nuevo después.',
  CHANGE_TO               : 'Cambiar a',
  CHANGES_SAVED           : 'Cambios guardados',
  CHANGES_SAVED_INFO      : 'Sus modificaciones %0 han sido guardadas!',
  CHANGING_CARRIER_TYPE   : 'Tipo de portador cambiado',
  CHANGING_SERVICE_TYPE   : 'Cambio de tipo de servicio',
  CHANGING_FROM           : 'Cambiando de',
  CHECK_STATUS            : 'Verificar estatus',
  CHIP_MEMORY             : 'Memoria del chip',
  CHIP_PART_NUMBER        : 'Chip Part Number',
  CHIP_TYPE               : 'Tipo de chip',
  CITY                    : 'Ciudad',
  CITY_TOO_LONG           : 'La ciudad no puede exceder los 35 caracteres',
  CLEAR                   : 'Limpiar',
  CLONE                   : 'Clon',
  CLOSE                   : 'Cerrar',
  CLOSED                  : 'Cerrado',
  COATING                 : 'Acabado',
  COATED                  : 'Recubierto',
  COATER1                 : 'Coater 1',
  COATER2                 : 'Coater 2',
  CODE                    : 'Código',
  COLOR_TONES             : 'Color / Tonos',
  COLLATED                : 'Coleado',
  COLLATING               : 'Coleando',
  COLLATING_SHEET_QTY     : 'Cantidad de sets a colear',
  COLLATOR                : 'Coleador',
  COMMENT                 : 'Comentario',
  COMMENT_ERROR           : 'El comentario no puede exceder los 500 caracteres',
  COMMENT_TEXT            : 'Texto del comentario',
  COMPANY                 : 'Empresa',
  COMPANY_TOO_SHORT       : 'La empresa debe tener al menos 3 caracteres',
  COMPANY_TOO_LONG        : 'La empresa no puede exceder los 35 caracteres',
  COMPLETED               : 'Concluido',
  CONFIG_ALREADY_EXISTS   : 'La configuración ya existe. Por favor, intente con un Subensamblaje y/o Presta diferente.',
  CONFIG_DELETED          : 'Configuración borrada correctamente.',
  CONFIGS_UPDATED         : 'Configuraciones actualizadas correctamente.',
  CONFIGURE_STD_HORIZON   : 'Configure el Horizonte Estándar para corte',
  CONFIRM_DELETE          : 'Confirmar Borrado',
  CONFIRM_DELETE_CONFIG_MESSAGE: '¿Está seguro de querer borrar esta configuración?',
  CONFIRM_PASSWORD        : 'Confirmar Contraseña',
  CONFIRM_PASSWORD_ENTRY  : 'Confirme su contraseña',
  CONFIRMED               : 'Confirmado',
  CONFIRM_CHANGE_CUT_MACHINE: 'Está seguro de querer cambiar la máquina de corte?',
  CONNECT                 : 'Conectar',
  CONTINUE                : 'Continuar',
  COORDINATOR             : 'Coordinador',
  COPIES                  : 'Copias',
  COUNT                   : 'Count',
  COUNTRY_CODE            : 'País Códigoe',
  COUNTRY_CODE_TOO_LONG   : 'El País Códigoe no puede exceder los 2 caracteres',
  CREATE                  : 'Crear',
  CREATE_NEW_CONFIG       : 'Crear nueva configuración',
  CREATE_NEW_CONFIG_INFO  : 'Por favor, introduzca el Subensamblaje y Presta para crear una nueva configuración.',
  CREATE_ACCOUNT          : 'Crear cuenta',
  CREATE_YOUR_ACCOUNT     : 'Crea tu cuenta',
  CREATED_DATE            : 'Fecha de creación',
  CSAPPROVAL              : 'Aprobación CS',
  CSHOLD                  : 'Detenidos CS',
  CURRENT_HORIZON         : 'Horizonte Actual',
  CURRENT_LASER           : 'Láser Actual',
  CURRENT_MATERIAL        : 'Material Actual',
  CURRENT_PRESSURE        : 'Presión Actual',
  CURRENT_PRINTERS        : 'Impresoras Actuales',
  CURRENT_SCANNERS        : 'Escáneres actuales',
  CURRENT_STATUS          : 'Estatus Actual',
  CUSTOM_SIZE_JOB_ERROR : 'Trabajos de tamaño personalizado no se pueden cambiar a corte en HORIZON.',
  LASER_CONFIG_JOB_ERROR : 'Este trabajo se encuentra en el listado de configuraciones de Material y Plantilla Presta para Láser.Está deshabilitado corte en Horizon.',
  DIE_OFF_HORIZON_ERROR   : 'El troquel está APAGADO. El corte en Horizon no está disponible.',
  CUSTOMER                : 'Cliente',
  CUSTOMER_EMAIL          : 'Cliente correo electrónico',  
  CUSTOMER_ID             : 'ID de cliente',
  CUSTOMER_REQUEST        : 'Requerimiento Especial de Cliente',
  CUSTOMER_REQUEST_MSG    : 'Trabajo debe cortarse UNICAMENTE en máquina %0.',
  CUSTOMER_DATES          : 'Fechas Solicitadas por el Cliente',
  CUSTOMER_DELIVERY_DATE  : 'Fecha de Entrega Solicitada por el Cliente',
  CUSTOMER_DUE_DATE       : 'Fecha Límite Solicitada por el Cliente',
  CUSTOM_SIZE             : 'Tamaño Personalizado',
  CUTTING_TYPE            : 'Tipo de corte',
  CUT                     : 'Corte',
  CUT_NEXT                : 'Iniciar el corte',
  CUT_USER                : 'Usuario para el estado Cut',
  CUT_UPDATED             : 'Actualizado para el estado de corte',
  CUT_ON_LASER            : 'Corte en el láser',
  CUT_DONE                : 'Hecho el corte',
  CUTTING                 : {
    START: 'Iniciar el corte',
    NAME : 'Cortando'
  },
  CUTTING_ERROR        : 'Error al cortar. Por favor, intente nuevamente. Si el problema persiste, por favor, contacte a un administrador.',
  DARK_BORDER_SCALE    : 'Escala de borde oscuro',
  DAYS_BEHIND_NBD      : '%0 día(s) después del Siguiente Día Hábil',
  DAYS_DUE             : '%0 día(s)',
  DAYS_PAST_DUE        : '%0 día(s) atrasado',
  DAYS_UNTIL_DUE       : '%0 día(s) hasta',
  DAYS_UNTIL_DUE_HEADER: 'Días antes de Fecha Límite',
  DAYS                 : 'Días',
  SUBMITTED_TO_DFE     : 'Ingresada al DFE',
  DEFAULT_PRESSURE     : 'Presión por Defecto',
  DELETE               : 'Borrar',
  DELETE_ITEM_HEADER   : 'Borrar %0',
  DELETE_ITEM_CONFIRM  : '¿Está seguro de que desea borrar el %1 "%0"?',
  DELIVERY_CONFIRMATION: 'Confirmación de entrega',
  DELIVERY_DATE        : 'Fecha de entrega',
  DESELECT_ALL         : 'Deseleccionar todo',
  DELIVERY_EXPECTED    : 'Fecha de entrega esperada',
  DESCRIPTION          : 'Descripción',
  DESIGN_DESCRIPTION   : 'Descripción del diseño',
  DID_YOU_SAVE_INLAYS  : '¿Guardaste los inlays?',
  DIE_MANAGER          : 'Administrador de Dados',
  DIE_SCAN_HISTORY     : 'Historial de escaneo de dado',
  DIE_NUMBER           : 'Número de dado',
  DIE_PRESSURE         : 'Presión del dado',
  DIE_PRESSURE_MAX_ERROR: 'La presión del dado debe ser inferior a %0',
  DIE_PRESSURE_MIN_ERROR: 'La presión del dado debe ser mayor a %0',
  DIE_PRESSURE_MODIFIED: 'La presión del dados todavía se está modificando',
  DIE_PRESSURE_MULTIPLE_ERROR: 'La presión del dado debe ser un múltiplo de %0',
  DIENOTAVAILABLE      : 'Dado',
  DIE_SCANNED          : 'Matriz Escaneada con Éxito',
  DIE_INVALID          : 'El dado no es válido. Escanee el dado correcto.',
  DIE_INACTIVE         : 'El troquel no está activado',
  DIES                 : 'Dados',
  DIE                  : 'Dado',
  DIE_STATUS           : 'Estado del Dado',
  DIE_LIST             : 'Die List',
  DISCONNECT           : 'Desconectar',
  DONE                 : 'Hecho',
  DONE_PICKING         : 'Hecho Picking',
  DOWN                 : 'Abajo',
  DOWNLOAD_REPORT      : 'Descargar Informe',
  DPO_HOLD             : 'DPO Hold Reason',
  DROPSHIP_ORDER        : 'No usar etiquetas o empaque con el logo de Avery. Usar etiquetas en blanco para cerrar los rollos y cajas.',
  DROPSHIP_MSG         : 'Orden de entrega - Revisé todos los rollos del envío y me aseguré de que los rollos tienen etiquetas de cierre en blanco (sin el logo de Avery)',
  // DROPSHIP_CHECK_BOX   : 'Sí, todas las cajas están en blanco (Sin logo de Avery).',          
  // DROPSHIP_CHECK_CLOSE : 'Sí, todos los rollos tienen etiquetas de cierre en blanco',    
  DUE_DATE             : 'Fecha Límite',
  DUE_DATE_PASSED      : 'día(s) hasta el vencimiento',
  DUE_DATE_UPCOMING    : 'día(s)',
  DUE_LATER            : 'Adelantado',
  DUE_TODAY            : 'Fecha Límite Hoy',
  DUE_TOMORROW         : 'Fecha Límite Mañana',
  DUE_NEXT_BUSINESS_DAY: 'El próximo día laborable',
  DUPLO                : 'Duplo',
  EDIT                 : 'Editar',
  EDIT_ADDRESS         : 'Editar dirección',
  EDIT_PRODUCT         : 'Editar producto',
  EDIT_PROFILE         : 'Editar perfil',
  EDIT_SHIPPING_ADDRESS: 'Editar dirección de envío',
  EDIT_TEMPLATE        : 'Editar plantilla',
  EDIT_IMPOSITION_TEMPLATE: 'Editar plantilla de imposición',
  EDITADO_SHEET_QA     : 'Revisión de Reimpresión Editada',
  EDITADO_SHEET_QA_BODY_1: 'Este trabajo fue Editado y Reimprimido.',
  EDITADO_SHEET_QA_BODY_2: 'Favor de revisar y asegurarse de tener en sus manos la ',
  EDITADO_SHEET_QA_BODY_3: 'Si tiene un Reimpresión a esta favor de tirarla y anotarla como Scrap.',
  EDITADO_REPRINTS       : 'Reimpresion',
  EFF_HEIGHT           : 'Altura efectiva',
  EFF_WIDTH            : 'Anchura efectiva',
  EMAIL                : 'Email',
  EMAIL_CONFIG         : 'Configuración del correo electrónico',
  EMAIL_INVALID        : 'Por favor, introduzca un correo electrónico válido',
  EMAIL_REQUIRED       : 'Se requiere correo electrónico.',
  EMAIL_AVERY_REQUIRED : 'Se requiere un correo electrónico de Avery.',
  EMAIL_TOO_LONG       : 'El correo electrónico no puede exceder los 50 caracteres',
  EMPLOYEES            : 'Employees',
  END                  : 'End',
  END_OF_DAY           : 'End Of Day',
  ENGINEERING          : 'Ingeniería',
  ENTER_COMMENT        : 'Agregar un comentario:',
  ENTER_SCRAP          : 'Introducir Scrap',
  ENTER_SCRAP_TOTALS   : 'Por favor, introduzca los totales de rechazo (cantidad de hoja) para batch',
  ENTER_SCRAP_TOTALS_JOBS   : 'Por favor, introduzca los totales de rechazo (cantidad de hoja) para trabajo',
  ENTER_MISSING_SHEETS           : 'Ingrese Hojas Faltantes',
  EOD                  : {
    BATCHES_MISSING_SCRAP        : 'Hay batches a los que se les debe asignar un rechazo!',
    NAME                         : 'End of Day',
    COMPLETED_INFO               : 'El proceso de la EoD ha finalizado!',
    DESCRIPTION_FEATURE1         : 'exportar todos los envíos terminados a Magento y Staging/ILS systems',
    DESCRIPTION_FEATURE2         : 'informarle si la comunicación a los servicios antes mencionados ha tenido éxito o no',
    DESCRIPTION_FEATURE3         : 'generar un informe por correo electrónico y enviarlo a la lista de distribución',
    DESCRIPTION_HEADER           : 'El End of Day...',
    INDICATE_FEDEX               : 'Favor de indicar si este EoD es de FedEx.',
    INDICATE_EOD                 : 'Por favor, indique qué EoD procesar',
    INDICATE_LAST_OF_DAY         : 'Por favor, indique si este será el último EoD que será enviado en el día.',
    INDICATE_AMAZON              : 'Favor de indicar si este EoD es de AMAZON DIRECT FUFILLMENT.',
    INFO1                        : 'Usted puede reverso a ejecutar el proceso individual en caso de fallas.',
    INFO2                        : 'También puede realizar varias EoD al día.',
    FAILED_INFO                  : 'El proceso de la EoD ha fracasado!',
    HEADER                       : 'Proceso End of Day',
    HISTORY                      : 'Historia de la EoD',
    NEXT_BUSINESS_DAY            : 'Siguiente día laborable',
    NEXT_BUSINESS_DAY_PLACEHOLDER: 'Seleccione el siguiente día laborable',
    NO_SHIPMENTS                 : 'Actualmente no hay envíos pendientes o listos.',
    PROCESS                      : 'Procesar nuevo EOD',
    RETRY                        : 'Reintentar EoD',
    RUNNING                      : 'Actualmente se está ejecutando un proceso de EoD.',
    START                        : 'Inicie el proceso EoD',
    UNASSIGNED_MID               : 'Todavía hay envíos MID que aún no han sido asignados a una Yellow Bag!'
  },
  EOD_COMPLETED               : 'EoD Completo',
  EOD_FAILED                  : 'Fallo de EoD',
  ESTIMATED_DELIVERY          : 'Entrega Estimada',
  ESTIMATED_DELIVERY_DATE     : 'Fecha Estimada de Entrega',
  EXPORT_EXCEL                : 'Exportar de Excel',
  FACILITIES                  : 'Instalaciones',
  FAILED                      : 'Fracasado',
  FILTER_BY_SUBASSEMBLY       : 'Filtrar por Subensamblaje',
  FILTER_BY_PRESTA            : 'Filtrar por Presta',
  FILTER_SUBASSEMBLY_PRESTA_INFO: 'Por favor, introduzca el Subensamblaje y/o Presta para filtrar la lista.',
  FILTERED                    : 'Filtrado',
  FIND_DEFAULT_PRINTER        : 'Buscar Impresora Predeterminada',
  FINISH_BARCODE              : 'Finalizar código de barras',
  FINISH_CODE                 : 'Código de acabado',
  FINISHING_PROGRAM           : 'Programa de acabado',
  FINISHING_SIGNS             : 'Señalización de acabados',
  FINISHING_TEXTURE           : 'Textura de acabado',
  FINISHING_TYPE              : 'Tipo de acabado',
  FINISH_LAMINATING           : 'Laminado de acabado',
  FINISH_TYPE                 : 'Tipo de acabado',
  FIRSTNAME                   : 'Primer Nombre',
  FIRSTNAME_TOO_LONG          : 'El nombre no puede exceder los 16 caracteres',
  FRONT                       : 'Frente',
  FORGOT_PASSWORD             : '¿Olvidó su contraseña?',
  FORGOT_PASSWORD_INSTRUCTIONS: 'Ingrese su correo electrónico y le enviaremos instrucciones sobre cómo restablecer su contraseña.',
  FORGOT_PASSWORD_SENT        : 'Email de restablecimiento de contraseña enviado. Siga las instrucciones del correo electrónico para restablecer su contraseña.',
  FORGOT_PASSWORD_SENT_ERROR  : 'Ese correo electrónico no existe en nuestro sistema.',
  GENERATED_DATE              : 'Fecha de creación',
  GET_ESTIMATES               : 'Obtener presupuestos',
  GHS_PRINT_PENDING           : 'GHS Print Pendiente',
  GLOVIA                      : 'Glovia',
  GLOVIA_STATUS               : 'Glovia Status',
  GROUP                       : 'Grupo',
  GRAPHIC_WIZARD              : 'Graphic Wizard',
  GRAPHTEC                    : 'Graphtec',
  GUILLOTINE                  : 'Guillotina',
  GO_TO_GHS                   : 'Ir a Trabajos GHS',
  GO_TO_STICKER_JOBS          : 'Ir a Trabajos de Stickers',
  GO_TO_MANAGER               : 'Ir a Manager',
  HEIGHT                      : 'Altura',
  HELP                        : {
    ADMINS        : 'Administradores',
    BATCHING      : 'Dosificación',
    BINNING       : 'Atado',
    HELP          : 'Ayuda',
    PRINTER_CONFIG: 'Config de impresora',
    WORK_BUCKETS  : 'Cubetas de trabajo',
  },
  HISTORY                           : 'Historia',
  HOLD                              : 'Hold',
  HOLD_BINS                         : 'Hold Bins',
  HOLD_LIST                         : 'Lista Detenidos',
  HOLD_JOB                          : 'Hold Trabajo',
  HOLD_MODAL_OTHER_HEADER           : 'Introduzca un comentario (obligatorio)',
  HOLD_MODAL_COMMENT_HEADER         : 'Introduzca un comentario (opcional)',
  HOLD_REASON_LENGTH_ERROR          : 'El comentario no puede exceder los 60 caracteres',
  HOLD_REASON                       : 'Motivo de Detención',
  HOLE_PUNCH                        : 'Hole Punch',
  'HOLE_PUNCH_1-4'                  : 'Hole Punch 1/4"',
  'HOLE_PUNCH_5-32'                 : 'Hole Punch 5/32"',
  HOME                              : 'Hogar',
  HORIZONS                          : 'Horizons',
  HORIZON                           : 'Horizon',
  HORIZON_1                         : 'Horizon 1',
  HORIZON1                          : 'Horizon 1',
  HORIZON_2                         : 'Horizon 2',
  HORIZON2                          : 'Horizon 1',
  HORIZON_3                         : 'Horizon 3',
  HORIZON3                          : 'Horizon 1',
  HORIZON_LIST                      : 'Horizon List',
  HORIZON_ACTIVE                    : 'Horizon Active',
  HORIZON_ASSIGNMENT                : 'Horizon Assignment',
  HORIZON_CONFIGURATION             : 'Configuración de Horizon',
  HORIZON_SMARTSLITTER              : 'Horizon + Smart Slitter',
  HOURS                             : 'Hours',
  HUMAN_RESOURCE                    : 'Human Resource',
  ID                                : 'ID',
  IMAGES                            : 'Imágenes',
  IMPRESO_HELP                      : 'Ayuda Impreso',
  IMPOSED_PDF                       : 'Corte Archivo PDF',
  IMPOSITION                        : 'Imposición',
  IMPOSITION_CONFIG                 : 'Configuración de imposición | %0',
  IMPOSITION_EDITOR                 : 'Editor de Imposición',
  IMPOSITION_TEMPLATE_EDITOR        : 'Editor de plantillas de imposición',
  INACTIVE                          : 'Inactivo',
  INCLUDE                           : 'Incluir',
  INCLUDES_WHITE_INK                : "Incluye tinta blanca",
  INLAY_SHEETS_SCRAPPED             : '¿Cuántas hojas de inlay se han desechado?',
  INLINE_JOBCARD                    : 'Tarjeta de trabajo en línea',
  INPACKING_STICKERS                : 'Pegatinas InPacking',
  INFO_STRIP                        : 'Tira de información',
  INTERFACE                         : 'Interfaz',
  INTL_INVOICE_CONFIRM_HEADER       : 'Factura en Papel Requerida (Pedido %0)',
  INTL_INVOICE_CONFIRM_INFO         : 'Por favor, saque todos las copias de la factura de papel de la impresora de albaranes, feche y firme todos las páginas y póngalas en una bolsa en la parte superior del paquete.',
  INTL_INVOICE_CONFIRM_INFO2        : 'Sí, he firmado y fechado la factura y la he adjuntado al paquete para el Pedido %0',
  INTOUCH_ORDER                     : 'Orden InTouch - Pegar etiqueta del producto en el exterior de la caja para indicar su contenido.',
  IDCBAND_ORDER                     : 'Orden ID&C - Pegar etiqueta del producto en el exterior de la caja para indicar su contenido.',
  INVALID_DIE_ID_SCAN               : 'Die ID "%0" escaneado, por favor escanee "%1" en su lugar',
  INVALID_MATERIAL_ID_SCAN          : 'Material subconjunto "%0" escaneado, por favor, escanee "%1" en su lugar',
  INVALID_WEIGHT                    : 'Los envíos con un peso superior a 150 libras deben ser enviados por camión. Por favor, póngase en contacto con el equipo de almacén para organizar el envío por camión.',
  INVALID_SCAN_ERROR_TITLE          : 'Error en Estación de Bin para el Trabajo %0',
  INVALID_SCAN_ERROR_BODY           : "El estado del Trabajo <strong>%0</strong> es <strong>%1</strong>.<br><span>Este trabajo no puede moverse a un bin.</span>",
  INVALID_SCAN_REASONS              : {
    CS_HOLD     : "Favor de llevar el trabajo al equipo de Servicio al Cliente para su revisión.",
    CSAPPROVAL  : "Favor de llevar el trabajo al equipo de Servicio al Cliente para su revisión.",
    SYSTEMS     : "Favor de llevar el trabajo al equipo de Sistemas para su revisión.",
    QA          : "Favor de llevar el trabajo al equipo de Calidad para su revisión.",
    ENGINEERING : "Favor de llevar el trabajo al equipo de Ingeniería para su revisión.",
    SHIPPING    : "Favor de llevar el trabajo a tu Coordinator para su revisión.",
    DIENOTAVAILABLE         :  "Favor de llevar el trabajo a tu Coordinator para su revisión.",
    MATERIALNOTAVAILABLE    :  "Favor de llevar el trabajo a tu Coordinator para su revisión.",
    OTHER                   :  "Favor de llevar el trabajo a tu Coordinator para su revisión.",
    DPO         :  "Favor de llevar el trabajo a tu Coordinator para su revisión.",
    CANCELLED     : "Favor de colocar el trabajo en la charola de Scrap.",
    EOD_COMPLETED : "Favor de colocar el trabajo en la charola de Scrap.",
  },
  INVOICE                           : 'Factura',
  ITEMS_PER_SHEET                   : 'Artículos por hoja',
  JOB                               : 'Trabajo',
  JOB_CUTTING                       : 'Corte trabajos',
  JOB_BATCHED                       : 'Trabajo Batched',
  JOB_DETAILS                       : 'Detalles del trabajo',
  JOB_ID                            : 'ID de Trabajo',
  JOB_LIST                          : 'Lista de trabajos',
  JOB_NOT_FOUND                     : '¡Oops! No se encontró el trabajo "%0".',
  JOB_STATUS_UPDATED                : 'Estatus del trabajo actualizado',
  JOB_UPDATED                       : 'Trabajo actualizado',
  JOB_UPDATED_INFO                  : 'El trabajo "5" ha sido actualizado.',
  JOB_LOCATION_SCAN                 : 'Ubicación del trabajo escaneado',
  JOB_SPECIFIC                      : 'Trabajo Específicamente',
  JOBS                              : 'Trabajos',
  JOBS_IN_BATCH                     : 'Trabajos en este batch',
  JOBS_IN_ORDER                     : 'Trabajos en este orden',
  JOBS_IN_SHIPMENT                  : 'Trabajos en este envío',
  JOBS_READY                        : 'Trabajos listos',
  JOBS_UPDATED                      : 'Trabajos actualizados',
  JOBS_UPDATED_INFO                 : 'Se han actualizado los siguientes jobs:',
  LABEL                             : 'Etiqueta',
  LABEL_CREATED                     : 'Etiqueta creada',
  LAMINATED                         : 'Laminado',
  LAMINATING                        : 'Laminando',
  LAMINATOR                         : 'Laminador',
  LABEL_PRINT_ERROR                 : 'Error de la impresora de etiquetas',
  LABEL_PRINT_ERROR_INFO            : 'No podía imprimir. Vuelva a comprobar la configuración de la impresora.',
  LABELS                            : 'Etiquetas',
  LANGUAGE                          : 'Idioma',
  LASER                             : 'Láser',
  LASER_CONFIGURATION               : 'Configuración del Láser',
  LASER_FUNCTIONALITY: {
    ENABLE_LASER_CUTTING              : 'Habilitar Corte Láser',
    ENABLE_LASER_CUTTING_FOR_JOBS     : 'Habilitar corte láser para esta matriz',
    LASER_ELIGIBLE                    : 'Elegible para Láser',
    LASER_NOT_ELIGIBLE                : 'No Elegible',
    MOVE_TO_LASER_CUTTING             : 'Mover a Corte Láser',
    SUSPEND_DIE                       : 'Suspender Matriz',
    EXISTING_JOBS_AFFECTED            : 'Trabajos Existentes Afectados',
    EXISTING_DIES_AFFECTED            : 'Matrices Afectadas',
    FUTURE_ORDERS_AFFECTED_WARNING    : 'Las órdenes futuras que usen esta matriz serán cortadas con láser hasta que la matriz sea habilitada nuevamente.',
    LASER_ENABLED_INFO                : 'Los trabajos existentes en HOLD debido a esta matriz serán cambiados para usar corte láser, y los trabajos futuros usarán corte láser en lugar de ser puestos en HOLD.',
    LASER_DISABLED_INFO               : 'Todos los trabajos que requieran esta matriz serán puestos en HOLD hasta que la matriz sea habilitada nuevamente.',
    TEMPLATE_LASER_DISABLED           : 'Template no está habilitado para corte en Láser en Magento. No se puede mover a corte en Láser.'
  },
  LASER_ENABLED                     : 'Láser Activado',
  LASER_ENABLED_MSG                 : 'Are you sure to update the Laser Enabled flag?',
  LASER_ENABLED_SUB_MSG             : 'By updating this flag, all nested configurations of this item will be updated too. If you want to add change to a specific pair of material and template then please go to nested configuration page.',
  LASER_MANIFEST                    : 'Manifiesto del Láser',
  LAST_SHIPMENT_LINE                : 'Última línea para el envío',
  LAST_SHIPMENT_LINE_HOLD           : 'Seleccione por lo menos una línea para pasar a On Hold',
  LASTNAME                          : 'Apellido',
  LASTNAME_TOO_LONG                 : 'El apellido no puede exceder los 16 caracteres',
  LAST_MONTH                        : 'Último Mes',
  LAST_WEEK                         : 'La semana pasada',
  LATE                              : 'Tarde',
  LEFT                              : 'Izquierda',
  LEVEL                             : 'Nivel %0',
  LIST_NETWORK_INFO                 : 'Lista de información de red',
  LINES                             : 'Líneas',
  LAST_LOCATION                     : 'Última Ubicación',
  LOCATION                          : 'Ubicación',
  LOGIN                             : 'Iniciar sesión',
  LOGIN_HERE                        : 'Iniciar sesión aquí',
  LOGOUT                            : 'Cerrar sesión',
  LOGOUT_MSG                        : 'Cerrar sesión....',
  MACHINE                           : 'Máquina',
  MACHINE_CAPACITY                  : 'Máquina Capacity',
  MACHINE_LOCATION_SCANNERS         : 'Escáneres de localización de máquinas',
  MAGENTO_ORDER_ID                  : 'Magento ID de Orden',
  MAGENTO_STATUS                    : 'Estatus de Magento',
  MAKE_TO_STOCK                     : 'Precortadas',
  MARGINS                           : 'Márgenes',
  MARKETPLACE_ORDER_NUMBER          : 'NÚMERO DE ORDEN DE MERCADO',
  MARKETPLACE_ORDERS                : 'Mercado De Pedidos',
  MATERIAL                          : 'Material',
  MATERIALNOTAVAILABLE              : 'Material N/A',
  MATERIAL_FINISH                   : 'Acabado del material',
  MATERIAL_MANAGER                  : 'Administrador de Material',
  MATERIAL_NAME                     : 'Nombre del material',
  MATERIAL_SUBASSEMBLY              : 'Subconjunto de material',
  MATERIAL_SCANNED                  : 'Material escaneado correctamente',
  MATERIAL_INVALID                  : 'El material no es válido. Por favor, escanee el material correcto.',
  MATERIAL_INACTIVE                 : 'El material no está activado',
  MATERIAL_NESTED_CONFIG            : 'Material Nested Configuration',
  MEASUREMENT                       : 'Medición',
  MESSAGE_TO_PRODUCTION             : 'Mensaje a la producción',
  MESSAGE_SPECIAL_REQUEST           : 'Introduzca un mensaje de solicitud especial',
  MISSING_ARTWORK_ERROR             : 'Error de falta de material gráfico',
  MISSING_BILLING                   : 'Falta información de facturación',
  MISSING_DUE_DATE                  : "Falta de fecha de vencimiento",
  MISSING_DELIVERY_DATE             : "Falta la fecha de entrega",
  MISSING_DATES                     : "Fechas que faltan",
  MISSING_SHEETS                    : 'Hojas que faltan',
  MISSING_SETS                      : 'Sets faltantes',
  MISSING_DATES_ERROR               : {
    JOB_ERROR                       : 'No se puede reanudar el trabajo con fechas faltantes.',
    ORDER_ERROR                     : 'No se puede reanudar la orden con fechas faltantes.',
    ERROR_BODY                      : 'La fecha de producción y la fecha estimada de entrega deben ser ingresadas antes de liberar el trabajo'
  },
  MOVE_TO_ON_HOLD                   : 'Poner en Hold',
  MOVE_TO_LAMINATED                 : 'Pasar a laminado',
  MOVE_TO_LAMINATING                : 'Pasar a Laminando',
  MOVE_TO_SUPERBIN                  : 'Pasar a Superbin',
  MTO_ORDERS                        : 'MTO Orders',
  MTO_CARDS_PRODUCT                 : 'MTO Product',
  MTO_PRODUCT_INSTRUCTIONS          : 'Instrucción de embalaje de productos MTO',  
  MTS_WORKORDERS                    : 'Precortadas',
  MY_PROFILE                        : 'Mi Perfil',
  MULTI_LINE                        : 'Multi Line',
  MULTI_LINE_ORDER                  : 'Multi-Line Order',
  NAME                              : 'Nombre',
  NAVIGATE_TO_TEMPLATES             : 'O, hacer una nueva plantilla',
  NETWORK_INFO                      : 'Información de red',
  NETWORK_CONNECTION                : 'No hay conexión de red. Tratando de reconectar...',
  NEW                               : 'Nuevo',
  NEW_PASSWORD                      : 'Nueva contraseña',
  NEW_PASSWORD_REQUIRED             : 'Por favor, introduzca una nueva contraseña',
  NEW_PRESSURE                      : 'Nueva Presión',
  NEW_SHIPMENT_CREATED              : 'Nuevo envío creado',
  NEW_SHIPMENT_FINISHED             : 'Envío completado',
  NEW_SHIPMENT_CREATED_ERROR        : 'No se pudo crear el transporte',
  NEW_SHIPMENT_CREATED_ERROR_INFO1  : 'Lo sentimos, algo salió mal al intentar crear un envío para el pedido',
  NEW_SHIPMENT_CREATED_ERROR_INFO2  : 'Por favor, inténtalo de nuevo. Si el problema persiste, póngase en contacto con el administrador del sistema.',
  NEW_SHIPMENT_CREATED_INFO1        : 'Nuevo envío ha sido creado! Favor de colocar la orden',
  NEW_SHIPMENT_CREATED_INFO2        : 'en el siguiente Bin',
  NEW_SHIPMENT_CREATED_INFO3        : 'Nuevo envío ha sido creado! Favor de colocar la orden',
  NEW_SHIPMENT_CREATED_INFO4        : 'Tenga en cuenta que desde el pedido',
  NEW_SHIPMENT_CREATED_INFO5        : 'sólo contiene 1 línea, no se ha asignado ninguna ubicación a este transporte.',
  NEW_SHIPMENT_CREATED_INFO6        : 'Favor de llevar la orden',
  NEW_SHIPMENT_CREATED_INFO7        : 'ubicada en el Bin #',
  NEW_SHIPMENT_CREATED_INFO8        : ' a la estación de Empaque',
  NEW_SHIPMENT_CREATED_INFO9        : 'ubicada en el ',
  NEW_USER                          : 'Nuevo Usuario',
  NEW_HOLDBIN_CREATED               : 'Nuevo Hold Bin creado',
  NEW_HOLDBIN_CREATED_INFO1         : 'Por favor, utilice Hold BIN ',
  NEW_HOLDBIN_CREATED_INFO2         : 'para colocar todos los jobs de la orden ',
  NEXT                              : 'Siguiente',
  NEXTBUSINESSDAY                   : 'El próximo día hábil',
  NEXT_DAY                          : 'El día sig',
  NO                                : 'No',
  NO_BATCHES_TO_CUT                 : 'No hay más batches que corte!',
  NO_DIE_CUTTING_REQUIRED           : 'No es necesario troquelar',
  NO_DIE_REQUIRED                   : 'No requiere dado.',
  NO_ELIGIBLE_REPRINT_JOBS          : 'No hay trabajos elegibles para reimpresión.',
  NO_SEARCH_RESULTS                 : 'No hay resultados de búsqueda',
  NO_SEARCH_RESULTS_INFO            : 'Lo sentimos, no se han encontrado coincidencias para "%0"',
  NO_SUPER_BIN_TITLE                : 'No hay Super Bin disponible',
  NO_SUPER_BIN_BODY                 : 'No hay Super Bins disponibles. Por favor, póngase en contacto con la administración de la planta.',
  NOT_OKAY_HOLD                     : 'No OK / Poner en Hold',
  NONE                              : 'Ninguna',
  NOTES                             : 'Notas',
  NUMBER_OF_CELLS                   : 'Número de Celdas',
  NUMBER_OF_COPIES                  : 'Número de copias',
  NUMBER_OF_LINES                   : 'Número de Líneas',
  NUMBER_OF_JOBS                    : '# de Trabajos',
  NUMBER_OF_SHEETS                  : 'Número de Hojas',
  NUMBER_OF_SHEETS_MISSING          : 'Número de hojas que faltan',
  NUMBER_OF_SIDES                   : 'Número de Côtés',
  OK                                : 'OK',
  OLD_PASSWORD                      : 'Contraseña antigua',
  OLD_PASSWORD_INCORRECT            : 'La contraseña antigua introducida es incorrecta.',
  OLD_PASSWORD_REQUIRED             : 'Por favor, introduzca su contraseña antigua',
  OLD_PRESSURE                      : 'Presión Antigua',
  ON_CREATE                         : 'Creado %0',
  ON_CREATE_ERROR                   : 'No pudo crear %0',
  ON_CREATE_ERROR_INFO              : 'Lo sentimos, algo salió mal al intentar crear el %0',
  ON_CREATE_INFO                    : 'Su nuevo %0 ha sido creado con éxito!',
  ON_DELETE                         : '%0 suprimido',
  ON_DELETE_INFO                    : 'Su %0 "%1" ha sido borrado correctamente!',
  ON_HOLD                           : 'Detenidos',
  ON_HOLD_BATCH_JOB_CONFIRM         : 'Colocar este trabajo On Hold lo eliminará de este batch.',
  ON_HOLD_BATCH_JOB_CONFIRM_HEADER  : 'Por favor, seleccione un motivo para poner este trabajo On Hold (requerido).',
  ON_HOLD_BATCH_JOB_LAST            : 'Este es el único job restante del batch. Colocar este trabajo On Hold eliminará este batch!',
  ON_HOLD_CONFIRM                   : 'Por favor, introduzca una razón para poner este %0 On Hold. (Requerido)',
  ON_HOLD_HEADER                    : 'Retención %0',
  ON_HOLD_DIE_WARNING_HEADER        : 'Nota: Esto retendrá el troquel del trabajo actual. Al retener el troquel se pondrán en espera todos los trabajos que compartan el mismo troquel.',
  ON_HOLD_MATERIAL_WARNING_HEADER   : 'Nota: Esto mantendrá el trabajo actual del trabajo actual. Al retener el material, se retendrán todos los trabajos que compartan el mismo material.',
  ON_LASER                          : 'En Láser',
  ON_TIME                           : 'A tiempo',
  ON_NOT_LOADED_ERROR               : '%0 sin carga',
  ON_NOT_LOADED_ERROR_INFO          : 'Lo sentimos, no hemos podido cargar ningún dato %0',
  ON_UPDATE_ERROR                   : 'No se pudo actualizar %0',
  ON_UPDATE_ERROR_INFO              : 'Lo sentimos, algo salió mal al intentar actualizar el %0',
  ON_UPLOAD                         : '%0 subido',
  ON_UPLOAD_INFO                    : 'Tu %0 "%1" ha sido subido con éxito!',
  ON_UPLOAD_ERROR                   : 'No se puede cargar %0',
  ON_UPLOAD_ERROR_INFO              : 'Lo sentimos, algo salió mal al intentar cargar el %0',
  ONPRESS_REASON                    : 'OnPress Razón',     
  ONPRESS_UPDATED                   : 'OnPress actualizado',   
  ONE_SIDED                         : 'Una cara',
  OPEN                              : 'Abierto',
  OPEN_BATCH                        : 'Abierto Batch',
  OPEN_PDF                          : 'Abrir PDF',
  OPENED                            : 'Abierto',
  ORDER                             : 'Pedido',
  ORDER_AND_YB_ID                   : 'Pedido / Yellow Bag ID',
  ORDER_CANCELLED_HEADER            : 'Orden Cancelada',
  ORDER_CANCELLED_INFO              : 'El pedido "%0" se ha cancelado con éxito',
  ORDER_DATE                        : 'Fecha de pedido',
  ORDER_DETAILS                     : 'Detalles del pedido',
  ORDER_DETAILS_HEADER              : 'Pedido %0',
  ORDER_DETAILS_BACK                : 'Reverso a la lista de pedidos',
  ORDER_DESCRIPTION                 : 'Descripción de Orden',
  ORDER_ID                          : 'ID de Orden',
  ORDER_ERROR_TITLE                 : 'Error de orden diferente',
  ORDER_ERROR_BODY                  : 'Se escaneo una hoja de una orden diferente. Favor de revisar todos los trabajos de esta orden.',
  ORDER_FOUND_WRONG_SYSTEM          : 'Pedido encontrado, sistema incorrecto',
  ORDER_FOUND_WRONG_SYSTEM_INFO1    : 'El ID que ha escaneado (<strong>%0</strong>) pertenece a un sistema diferente.',
  ORDER_FOUND_WRONG_SYSTEM_INFO2    : '<strong>Sistema actual</strong>: %0',
  ORDER_FOUND_WRONG_SYSTEM_INFO3    : '<strong>Sistema escaneado</strong>: %0',
  ORDER_NOT_FOUND                   : '¡Oops! No se encontró el pedido "%0".',
  ORDER_PAST_DUE                    : 'Esta Orden es %0 día(s) de atraso!',
  ORDER_STATUS_UPDATED              : 'Estatus de la orden actualizado',
  ORDER_UPDATED                     : 'Pedido actualizado',
  ORDER_UPDATED_INFO                : 'El pedido "5" ha sido actualizado.',
  ORDERED_TOTAL                     : 'Ordenado Total',
  ORDERED_QTY                       : 'Cantidad ordenada',
  ORDERS                            : 'Órdenes',
  ORDERS_CUT                        : 'Corte de pedidos',
  ORDERS_LIST                       : 'Lista de órdenes',
  ORDERS_RECEIVED                   : 'Pedidos recibidos',
  ORDERS_UPDATED                    : 'Pedidos actualizados',
  ORDERS_UPDATED_INFO               : 'Se han actualizado las siguientes órdenes:',
  ORIGIN                            : 'Origen',
  ORIGINAL_DUE_DATE                 : 'Fecha de vencimiento original',
  ORIGINAL_SERVICE_TYPE             : 'Tipo de servicio original',
  OTHER                             : 'Otros',
  OTHER_REASON                      : 'Otra Razón',
  OTHER_REASON_REQUIRED             : 'Por favor provea otra razón.',
  OVER_COUNT_TITLE                  : 'Error de recuento',
  OVER_COUNT_BODY                   : "Ya se escanearon la cantidad correcta para el trabajo %0. Favor de continuar con el siguiente trabajo.",
  OVERDUE                           : 'Este %0 ha vencido hace %1 día(s)',
  OVERLAY                           : 'Superposición',
  OVERLAY_ADD_DELETE                : 'Agregar/borrar superposición',
  OVERLAY_DELETE_ERROR              : 'Error de borrado de sobreimpresión de la plantilla Error de borrado de PDF',
  OVERLAY_DELETE_ERROR_INFO         : 'Algo salió mal cuando se intentó eliminar la sobreimpresión de plantilla PDF',
  OVERLAY_FILE                      : 'Archivo de superposición',
  OVERLAY_FILE_CURRENT              : 'Archivo de superposición actual',
  OVERLAY_FILE_SELECT               : 'Seleccione un archivo de superposición',
  OVERLAY_FILE_SELECT_INFO          : 'O bien, cargue un PDF de su elección',
  OVERLAY_MANAGE                    : 'Administrar superposiciones',
  OVERLAY_MANAGER                   : 'Administrador de superposición',
  OVERLAY_PDF                       : 'Sobreimpresión PDF',
  OVERLAYS                          : 'Sobreimpresiones',
  OVERLAYS_MISSING                  : 'Falta de superposiciones',
  OVERWEIGHT                        : 'Máximo 150 libras por caja',
  PACKAGES                          : 'Paquetes',
  PACKAGE_NUMBER                    : 'Número de paquete',
  PACKAGE_MATERIAL                  : 'Material de paquete',
  PACKAGE_MATERIAL_NEEDED_ERROR     : 'Error en Material de Paquete',
  PACKAGE_MATERIAL_NEEDED_ERROR_BODY : 'Material de Paquete no puede estar vacío. Favor de agregar Bocket.',
  PACKAGE_TYPE                      : 'Tipo de paquete',
  PACKED                            : 'Empacado',
  PACKING                           : 'Empaque',
  PACKING_JOBS                      : 'El trabajo sigue siendo de embalaje',
  PACKING_STILL_IN                  : ' todavía en el embalaje.',
  PACKING_FINISH                    : 'Por favor, termina de empacar y muévete a la sección de envíos antes de comenzar a empacar otro trabajo.',
  PACKING_SLIP                      : 'Ficha de Embalaje',
  PACKING_SLIP_PRINT_SUCCESS        : 'Hoja de embalaje impresa',
  PACKING_SLIP_PRINT_SUCCESS_INFO   : 'La hoja de embalaje para la orden "%0" se ha impreso a partir de "%1".',
  PACKAGING_LABEL                   : 'Etiqueta de Embalaje',
  PACKAGING_LABEL_MODAL_HEADER      : 'Etiqueta de empaquetado de impresión',
  PACKAGING_LABEL_PRINT_INSTRUCTION : 'Ingrese la cantidad de hojas que van al paquete y haga clic en imprimir.',
  PACKAGING_LABEL_PRINT_SUCCESS     : 'Etiqueta de embalaje impresa',
  PACKAGING_LABEL_PRINT_SUCCESS_INFO: 'La etiqueta de embalaje para la orden "%0" se ha impreso a partir de "%1".',
  PACKAGING_USER                    : 'Usuario para el estado del embalaje',
  PACKAGING_UPDATED                 : 'Actualizado para el estado de embalaje',
  PAGE_FROM                         : 'Hoja de prensa de',
  PAGE_FROM_ERROR1                  : 'La página de no puede ser inferior a la página a.',
  PAGE_FROM_ERROR2                  : 'La página desde no puede ser inferior o igual a la página anterior a.',
  PAGE_FROM_ERROR1N2                : 'La página de no puede ser inferior a la página a. La página desde no puede ser inferior o igual a la página anterior a.',
  PAGE_NOT_A_NUMBER                 : 'La página no es un número',
  PAGE_RANGE_INVALID                : 'Intervalo de páginas no válido, utilice, por ejemplo, 1 a 5, 11 a 11',
  PAGE_TO                           : 'Presione la hoja para',
  PAGE_SCAN_MSG                     : 'Favor de escanear cada hoja individual de este trabajo.',
  PAGES                             : 'Páginas',
  PARENT_TRACKING_NUMBER            : 'Número de seguimiento de los padres',
  PARTIAL_RECUT                     : 'Corte sólo una parte de las %0 hojas originales',
  PARTIAL_REPRINT                   : 'Reimprimir Parcial',
  PASSWORD                          : 'Contraseña',
  PASSWORD_MATCH_REQUIRED           : 'Las contraseñas proporcionadas no coinciden',
  PASSWORD_REQUIRED                 : 'Por favor, introduzca una contraseña.',
  PASSWORD_UPDATED                  : 'Contraseña actualizada',
  PASSWORD_UPDATED_INFO             : 'Su contraseña ha sido actualizada con éxito!',
  PAST_7_DAYS                       : 'Últimos 7 días',
  PAST_DUE                          : 'Tarde',
  PERCENT_OF_JOBS                   : '% de Trabajos',
  PERCENT_OF_SHEETS                 : '% de Hojas',
  PENDING                           : 'Pendiente',
  PENDING_PRINTING                  : 'Pendiente Printing',
  PENDING_PRINTING_WARN             : 'Orden %0 se encuentra en Pendiente Printing. Sólo un integrante de Servicio al Cliente puede liberarla.',
  PENDING_PRINTING_CS_BODY          : 'El trabajo se encuenta en estado de Pendiente Printing, favor de llevarlo a un miembro del equipo de Servicio al Cliente para que lo revisen.',
  PENDING_SHIPMENT                  : 'Envío Pendiente',
  PENDING_SHIPMENTS                 : 'Envío Pendientes',
  PENDING_TASKS                     : 'Tiene %0 tarea(s) pendiente(s)',
  PHONE                             : 'Teléfono',
  PHONE_NUMBER_REQUIRED             : 'Se requiere número de teléfono para envíos fuera de los Estados Unidos',
  PHONE_NUMBER_VALID_DOMESTIC_FORMAT: 'Se requieren al menos 10 dígitos',
  PHONE_NUMBER_CHARACTER            : 'Por favor, introduzca sólo números',
  PHYSICAL_ADDRESS                  : 'Dirección física',
  PLEASE_CHECK                      : 'Favor de revisar los siguientes puntos:',
  PLEASE_SELECT_HORIZON             : 'Por favor, seleccione un horizonte',
  PLEASE_CONFIRM                    : 'Please Confirm',
  PLEASE_ENTER_PASSWORD             : 'Por favor, introduzca una contraseña',
  PLEASE_SELECT_DATE                : 'Please Select Date',
  POSITION_FACE_DOWN                : 'Por favor coloca el arte boca abajo',
  POSITION_FACE_UP                  : 'Por favor coloca el arte boca arriba',
  POSTCODE_REQUIRED                 : 'Código postal requerido',
  POSTCODE_VALID_FORMAT_CA          : 'Código postal válido: A#A#A#A',
  POSTCODE_VALID_FORMAT_INTL        : 'Código postal válido: 9 caracteres alfanuméricos',
  POSTCODE_VALID_FORMAT_INTL_LENGTH : 'El código postal debe tener menos de 9 caracteres',
  POSTCODE_VALID_FORMAT_US          : 'Código postal válido: XXXXX-YYYYY o XXXXXXX o XXXXXYYYYY',
  PREFERRED_CUTTING                 : 'Corte preferido',
  PREFERRED_CUTTING_WARNING         : 'El corte preferente ha cambiado a %0 y es diferente del corte preferente original',
  PREPRESS                          : 'Preimpresión',
  PREPRINT                          : 'Preimpresión',
  PRESSES                           : 'Prensas',
  PRESSURES                         : 'Presiones',
  PRINT                             : 'Imprimir',
  PRINT_AND_BOX                     : 'Impresión y Caja',
  PRINT_AND_SHIP                    : 'Imprimir y Enviar',
  PRINT_READY                       : 'En Prensa',
  PRINT_READY_NEXT                  : 'Listo para imprimir',
  PRINT_STATION                     : 'Estación de impresión',
  PRINT_PROOF                       : 'Imprimir Proof',
  PRINT_WORK_ORDERS                 : 'Imprimir Órdenes de Trabajo',
  PRINTED                           : 'Impresos',
  PRINTED_NEXT                      : 'Impresión lista',
  PRINTED_REASON                    : 'Impresos Razón',
  PRINTED_UPDATED                   : 'Impresos Actualizado',
  PRINTER                           : 'Impresora',
  PRINTER_CONFIGURATION             : 'Configuración de la impresora',
  PRINTER_CONNECTION                : 'Conexión a la impresora',
  PRINTER_FOUND                     : 'Impresora encontrada',
  PRINTING                          : 'Impresión',
  PRINTING_ABORTED                  : 'Impresión Abortada',
  PRINTREADY                        : 'En Prensa',
  PROBLEM                           : 'Problema',
  PROCESS_SCRAP                     : 'Scrap de Proceso',
  PROCESSING                        : 'Procesamiento',
  PRODPENDING                       : 'Productos Pendientes',
  PROD_PENDING_PRINTING             : 'Producción pendiente de impresión',
  PRODUCT                           : 'Producto',
  PRODUCT_CLONE                     : 'Producto Clon',
  PRODUCT_CLONE_INFO                : 'Introduzca un nuevo nombre para el clon de producto de "%0" abajo',
  PRODUCT_CREATE_HELP               : 'O bien, cree un nuevo producto introduciendo el nombre del producto',
  PRODUCT_CREATED                   : 'Nuevo producto creado',
  PRODUCT_CREATED_INFO              : 'Producto "%0" ha sido creado!',
  PRODUCT_CONFIG                    : 'Configuración del producto | %0',
  PRODUCTION_DATES                  : 'Fechas de producción',
  PRODUCT_DELETE                    : 'Producto borrado',
  PRODUCT_DELETE_CONFIRM            : '¿Estás seguro de que quieres borrar "%0"?',
  PRODUCT_ID                        : 'ID de producto',
  PRODUCT_INFO                      : 'Información del producto',
  PRODUCT_NAME                      : 'Nombre del producto',
  PRODUCT_NEW                       : 'Nuevo Producto',
  PRODUCT_RENAME                    : 'Renombrar Producto',
  PRODUCT_RENAME_INFO               : 'Introduce un nuevo nombre para "%0".',
  PRODUCT_SELECT                    : 'Seleccione un producto',
  PRODUCT_SELECT_HELP               : 'Modificar, clonar o eliminar un producto existente',
  PRODUCT_SKU                       : 'Producto SKU',
  PRODUCT_SUBASSEMBLY_CREATE        : 'Se crea el subconjunto de nuevo producto',
  PRODUCT_SUBASSEMBLY_CREATE_INFO   : 'Se ha creado el subconjunto de productos "%0"!',
  PRODUCT_SUBASSEMBLY_DELETE        : 'Subconjunto de productos borrado',
  PRODUCT_SUBASSEMBLY_DELETE_INFO   : 'El subconjunto de productos "%0" ha sido borrado!',
  PRODUCT_SUBASSEMBLY_UPDATED       : 'Actualización del subconjunto de productos',
  PRODUCT_SUBASSEMBLY_UPDATED_INFO  : 'Actualización del subconjunto de productos "5" actualizado.',
  PRODUCT_UPDATED                   : 'Producto actualizado',
  PRODUCT_UPDATED_INFO              : 'El producto "%0" ha sido actualizado.',
  PRODUCTION_DUE                    : 'Fecha de Producción',
  PRODUCTION_DUE_DATE               : 'Fecha Límite de Producción',
  PRODUCTS                          : 'Productos',
  PRODUCTS_UPDATED                  : 'Productos actualizados',
  PRODUCTS_UPDATED_INFO             : 'Los siguientes productos han sido actualizados:',
  PROFILE                           : 'Perfil',
  PROGRESS                          : 'Progreso',
  PROMOTION                         : 'Pedido promocional',
  PROMOTIONAL_ORDERS                : 'Pedido promocionales',
  PROOF                             : 'Pruebas',
  PROOF_STATUS                      : 'Estado del Proof',
  PTO_BATCHES                       : 'PTO Batches',
  PTO_RACKS                         : 'PTO Racks',
  PTO_JOB                           : 'PTO Job',
  PTO_ORDERS                        : 'PTO Orders',
  PTO_SCAN                          : 'PTO Scan',
  PTO_SCAN_INVALID                  : 'PTO Scan Inválido',
  PTO_WORK_ORDER                    : 'PTO Work Order',
  PTO_PACKAGING_LABEL               : 'PTO Packaging Label',
  PTO_ARTICLE_CHECKLIST             : 'PTO Article Checklist',
  PTO_SCAN_INSTRUCTIONS             : 'Asegúrese de que la impresora esté configurada con los siguientes y proceda a imprimir',
  PTO_MAKE_TO_STOCK                  : 'Make To Stock: Después de imprimir, este trabajo irá a Empaquetado.',
  PTO_NO_MORE_BATCHES                : 'No hay más batches para procesar',
  PTO_NO_MORE_BATCHES_INFO           : 'Ya has procesado todos los batches.',
  PTO_BINS_TOTAL                     : 'Total de Contenedores',
  PTO_BINS_OCCUPIED                  : 'Contenedores Ocupados',
  PTO_BINS_AVAILABLE                 : 'Contenedores Disponibles',
  PTO_BINS_AVAILABLE_STATUS          : 'Disponible',
  PTO_BINS_READY_FOR_NEXT_BATCH      : 'Listo para el próximo batch',
  PTO_BINS_NO_BINS_AVAILABLE         : 'No hay Contenedores PTO Disponibles',
  PTO_BINS_CLICK_INIT                : 'Haga clic en "Init Bins" para crear los 20 contenedores PTO iniciales en la base de datos.',
  POSITION                          : 'Posición',
  POSTAL_CODE                       : 'Código Postal',
  PO_BOX_BLOCK                      : 'Tipo de Servicio no se puede cambiar para envíos a PO Box.',
  QA                                : 'QA',
  QAOK                              : 'QA OK',
  HOLD_BIN_MANAGER                  : 'Administrador de Hold Bin',
  HOLD_TEST_ORDER                   : 'Hold Test Order',
  QAOK_FULL                         : 'No hay Estaciones de Empaque disponibles',
  QAOK_FULL_BODY_1                  : 'No más de %0 envíos pueden estar en estado de QA OK.',
  QAOK_FULL_BODY_2                  : 'Favor de terminar los envíos para la(s) orden(es) %0 %1 primero.',
  QA_CHECK                          : 'Comprobación QA',
  QA_CHECK_FOR_ORDER                : 'Comprobación QA para Orden',
  QA_CHECK_JOB                      : 'Favor de revisar  lo siguiente en cada trabajo: ',
  QA_CHECK_JOB_LIST                 : 'Número de hojas, Calidad de impresión, Hojas dañadas / manchadas / faltantes, Acabado, Accesorios',
  QAOK_USER                         : 'QAOK Usuario',
  QAOK_REASON                       : 'QAOK Razón',
  QAOK_UPDATED                      : 'QAOK Actualizado',
  QA_HOLD_PROMPT                    : 'Seleccione los trabajos con problemas de calidad y añada un motivo de retención (requerido): ',      
  QTY                               : 'Cantidad',
  QTY_AND_MEASUREMENTS              : 'Cantidades y medidas',
  QTY_ORDERED                       : 'Cantidad ordenada',
  QTY_REMAINING                     : 'Cantidad restante',
  QUEUED                            : 'En Espera',
  QUEUED_IN_IMPRESO                 : 'Ingresada',
  QUANTITY                          : 'Cantidad',
  QUANTITY_MUST_BE_POSITIVE         : 'La cantidad debe ser mayor que 0',
  READY                             : 'Listo para Empacar',
  REASON                            : 'Motivo',
  RECUT                             : 'Recorte',
  RECUT_BODY                        : '¿Le gustaría recortar esta trabajo?',
  RECUT_HEADER                      : 'Recortar Trabajo',
  RECUT_QTY                         : 'Cantidad de recorte',
  RECUT_SHEETS                      : 'Recorte %0 hojas',
  REDOWNLOAD                        : 'Redescargar',
  REDOWNLOAD_DPO_ART                : 'Vuelva a descargar ilustraciones de DPO',
  REDOWNLOAD_ARTWORK                : 'Vuelva a descargar las ilustraciones cambiadas de DPO otra vez',
  REGEN_LASER                       : 'Archivos de Láser Regen',
  REGEN_PDF                         : 'Archivos PDF Regen',
  REGEN_LASER_BODY                  : 'Los archivos de láser se han regenerado con éxito',
  REENTER_PASSWORD                  : 'Verificar contraseña',
  REENTER_PASSWORD_MATCH            : 'Las contraseñas proporcionadas no coinciden.',
  REENTER_PASSWORD_REQUIRED         : 'Por favor, verifique su contraseña.',
  REGIONS                           : 'Regiones',
  REGISTER                          : 'Registro',
  REGISTER_NOW                      : 'Regístrese ahora',
  REJECT                            : 'Reject',
  REJECT_ALL                        : 'Reject All',
  REJECTED                          : 'Rejected',
  RELEASE_CS                        : 'Liberación CS',
  REMEMBER_PASSWORD                 : '¿Recuerdas tu contraseña?',
  REMOVE                            : 'Eliminar',
  REMOVE_PACKAGE_BOX                : 'Remover caja de embalaje',
  RENAME                            : 'Cambiar nombre',
  REPLACE                           : 'Reemplazar',
  REPLACE_DIE                       : 'Reemplazar el dado',
  REPLACE_DIE_CONFIRM               : '¿Está seguro de que desea reemplazar este dado y restablecer sus valores predeterminados de presión de dado?',
  REPORT                            : 'Informe',
  REPORT_SCRAP                      : 'Reporte de Scrap',
  REPORT_FILE                       : 'Archivo de informe',
  REPORT_STATUS                     : 'Estatus del informe',
  REPORTS                           : {
    REPORTS: 'Reportes',
    EQUIPMENT_UTIL   : 'Utilización del equipo',
    END_OF_MONTH     : 'Fin de mes',
    ORDER_COMPLETION : 'Órdenes completadas',
    ORDER_SHIPMENT: 'Pedido / Envío',
    SCRAP_REPRINT: 'Scrap / Reimpresión',
    REPRINT: 'Reimpresión',
    CUSTOMER_SERV : 'Servicio al cliente',
    ORDERS_REPORT: 'Informe de pedidos',
    COMPLAINT: 'Informe de denuncia',
    MATERIAL_USAGE: 'Informe sobre el uso de materiales',
    SYSTEM_FLOWCHART: 'System Flowchart',
    CAPACITY_REPORT: 'Capacity Report',
    EOM_REPORT: 'Informe de Fin de Mes',
    EOM: {
      TOTAL_SHIPMENTS: 'Total de Envíos',
      TOTAL_PACKAGES: 'Total de Paquetes',
      TOTAL_SHIPPING_COSTS: 'Costos Totales de Envío',
      AVG_COST_PER_SHIPMENT: 'Costo Promedio por Envío',
      SHIPMENTS_BY_CARRIER: 'Envíos por Transportista',
      SHIPPING_COSTS_BY_CARRIER: 'Costos de Envío por Transportista',
      SHIPMENTS_BY_BUSINESS_UNIT: 'Envíos por Unidad de Negocio',
      DAILY_SHIPPING_COST_TRENDS: 'Tendencias Diarias de Costos de Envío',
      COST_ANALYSIS_SUMMARY: 'Resumen de Análisis de Costos',
      CARRIER_PERFORMANCE: 'Rendimiento del Transportista',
      BUSINESS_UNIT_PERFORMANCE: 'Rendimiento de la Unidad de Negocio',
      SHIPMENT_SUMMARY: 'Resumen de Envíos',
      EOM_SHIPMENT_DETAILS: 'Detalles de Envíos de Fin de Mes',
      SHIPMENT_DETAILS: 'Detalles del Envío',
      NO_EOM_DATA: 'No hay datos de fin de mes disponibles para el rango de fechas seleccionado.',
      NO_DRIVER_SUMMARY: 'No hay datos de resumen del conductor disponibles',
      CARRIER: 'Transportista',
      SHIPMENTS: 'Envíos',
      TOTAL_COST: 'Costo Total',
      AVG_COST_SHIPMENT: 'Costo Promedio / Envío',
      BUSINESS_UNIT: 'Unidad de Negocio',
      SERVICE_TYPE: 'Tipo de Servicio',
      SHIPMENTS_PACKAGES: 'Envíos / Paquetes',
      DATE: 'Fecha',
      ORDER_ID: 'ID de Pedido',
      ACCOUNT_NUMBER: 'Número de Cuenta',
      WEIGHT_LBS: 'Peso (lbs)',
      PACKAGES: 'Paquetes',
      SHIPPING_COST: 'Costo de Envío',
      COST_PACKAGE: 'Costo/Paquete',
      COST_POUND: 'Costo/Libra',
      DESTINATION: 'Destino',
      ACTIONS: 'Acciones',
      TRACKING_NUMBER: 'Número de Seguimiento',
      WEIGHT: 'Peso',
      AVG_COST_PER_PACKAGE: 'Costo Promedio por Paquete',
      COST_PER_POUND: 'Costo por Libra',
      SHEETS: 'Hojas',
      ONLINE_AISLE: 'Pasillo en Línea',
      RFID: 'RFID'
    }
  },
  REPRINT           : 'Reimprimir',
  REPRINT_HEADER    : 'Reimprimir %0',
  REPRINT_JOB_LIST  : 'Reimprimir lista de trabajos',
  REPRINT_LABEL     : 'Reimprimir Etiqueta',
  REPRINT_MANIFEST  : 'Reimprimir Manifiesto',
  REPRINT_ORDER_INFO: 'ADVERTENCIA: La reimpresión de este pedido eliminará todos los contenedores y envíos asociados con este pedido!',
  REPRINT_RANGE     : 'Gama de Reimprimir',
  REPRINT_REASON_TABLE : 'Reprint Reason',
  REPRINT_REASON    : {
    HORIZON_ADJUSTMENT : 'Ajuste Horizon',
    DUPLO_ADJUSTMENT   : 'Ajuste Duplo',
    SMARTSLITTER_ADJUSTMENT : 'Ajuste Smart Slitter',
    MISSING_SHEETS     : 'Hojas Faltantes',
    TOTAL_LOSS         : 'Perdida Total',
    JAMMING            : 'Atoramiento',
    EDITED             : 'Editado',
    DIRTY_MATERIAL     : 'Material Sucio',
    PIP_MARKS_LINES_DOTS : 'Marcas de PIP / Mantilla / Rayas / Puntos',
    TONES              : 'Tonos',
    PROBLEMS_COATING   : 'Problemas con Acabado',
    DAMAGED_IN_PUNCHER : 'Dañado por el ponchado o perforado',
    CPR                : 'CPR',
    MATERIAL_DAMAGED_TRANSIT : 'Material dañado por traslado',
    BAD_CUT            : 'Mal Corte por TPH',
    POROUS_MATERIAL    : 'Material Poroso',
    INCORRECT_TEMPLATE : 'Template / Nombre del Producto Incorrecto',
    INCORRECT_MATERIAL : 'Material equivocado',
    INK_ADHERENCE      : 'Adherencia de tinta / descarapelado',
    DIRTY_GUILLOTINE   : 'Navaja de Guillotina sucia / desgastada',
    DUPLEX             : 'Duplex',
    JOB_STUCK          : 'Trabajo atorado',
    PROBLEM_JOB        : 'Problema de trabajo',
    LASER_CUT_WRONG    : 'Mal Corte en Laser'
  },
  REPRINT_REASON_HEADER           : 'Seleccione un motivo para reimprimir este %0',
  REPRINT_SELECTED_PAGES          : 'Reimprimir sólo las hojas seleccionadas de este trabajo',
  REPRINT_SIDE                    : 'Seleccionar lado a reimprimir',
  REPRINT_NUM_PAGES               : 'Sólo reimprimir el número de páginas introducidas',
  REPRINT_PAGES                   : 'Por favor, especifique el número de hojas a reimprimir (Requerido)',
  REPRINT_WORKORDERS              : 'Reimprimir las órdenes de trabajo',
  REPRINT_OKAY                    : 'Reprint Okay',
  REQUIRED                        : 'Requerido',
  REQUIRED_BY_OPERATOR            : 'Requerido por el operador',
  RESEND_TO_DFE                   : 'Reenviar a DFE',
  RESET                           : 'Restablecimiento',
  RESET_PASSWORD                  : 'Restablezca su contraseña',
  RESET_PASSWORD_DESCRIPTION      : 'Crear una nueva contraseña',
  RESET_PASSWORD_ERROR            : 'El correo electrónico y/o ficha proporcionados no coinciden.',
  RESET_PASSWORD_SHORT            : 'Restablecer contraseña',
  RESET_PASSWORD_SUCCESS          : 'Contraseña Restablecer Éxito',
  RESET_PASSWORD_USER             : 'Restablecer contraseña de usuario',
  RESET_PASSWORD_ADMIN_ERROR      : 'Necesita ser un administrador para cambiar la contraseña de usuario',
  RESET_PASSWORD_USER_ERROR       : 'Ha introducido una contraseña no válida',
  RESET_PASSWORD_ROLE_ERROR       : 'El usuario es un administrador. La contraseña no se puede restablecer.',
  RESUME                          : 'Reanudar',
  RESUME_NEXT                     : 'Reanudar, Siguiente',
  REVERT_TO_SEALED                : 'Reverso a Sellado',
  RFID_SHUFFLE_ORDER              : 'Orden de Mezcla RFID',
  RFID_ERROR_CODE_SCAN              : 'Código escaneado no concuerda con el código esperado. Favor de escanear el código correcto.',
  RFID_INVALID                      : 'Código RFID no válido',
  RFID_OUTERCASE_LABELS           : 'Etiquetas RFID para caja exterior',
  RFID_INNERCASE_LABEL            : 'Etiqueta RFID para caja interior',
  RFID_VALIDATION                 : 'RFID Validación',
  RFID_COUNT_ERROR                : 'Número de cantidad incorrecto. Por favor, cuente y vuelva a introducir el número',
  RFID_COUNT_SUCCESS              : 'Gracias. Por favor, mueva el trabajo al Bin correcto.',
  RFID_REPRINT_HEADER             : 'Reprint RFID',
  RFID_SAMPLES                    : 'RFID Muestras',
  RFID_SAMPLE_JOB                 : 'SKU de muestra RFID',
  RFID_SCRAP : {
    ENTER_RFID_SCRAP: "Ingresar Scrap RFID",
    SCRAP_CATEGORY: "Categoría de Scrap",
    SELECT_CATEGORY: "Seleccionar Categoría",
    SCRAP_REASON: "Razón de Scrap",
    SELECT_REASON: "Seleccionar Razón",
    SCRAP_QUANTITIES: "Cantidad de Scrap",
    FRONT_SHEETS: "Front Sheets",
    BACK_SHEETS: "Back Sheets",
    INLAY_SHEETS: "Inlay Sheets",
    FRONT_LAMINATE: "Front Laminate",
    BACK_LAMINATE: "Back Laminate",
    AT_LEAST_ONE_QUANTITY_REQUIRED: "Al menos una cantidad debe ser mayor que cero",
    CATEGORY_REQUIRED: "Categoría requerida",
    REASON_REQUIRED: "Razón requerida"
  },
  RFID_CARDS_PER_SHEET            : 'RFID Tarjetas por Hoja',
  RFID_CARDS                      : 'RFID Tarjetas',
  RFID_WAITING_UPLOAD               : 'Esperando a subir...',
  RFID_UPLOAD_COMPLETE              : 'Subida Exitosa',
  COUNT_VALIDATION_INSTRUCTION     : 'Por favor, cuente la cantidad disponible de este trabajo e ingrese el número para validar',
  ENTER_TOTAL_CARDS                : 'Ingrese el número total de tarjetas',
  KIND                             : 'Tipo',
  EXPECTED_COUNT                   : 'Cantidad Esperada',
  MISSING_CARDS_INFO               : 'Información de Recuento de Tarjetas',
  EXPECTED                         : 'Esperadas',
  COUNTED                          : 'Contadas',
  MISSING                          : 'Faltantes',
  SETS                             : 'conjuntos',
  BASED_ON_21_CARDS_PER_SET        : 'basado en 21 tarjetas por conjunto',
  INSUFFICIENT_CARDS_WARNING        : 'Advertencia: El recuento de tarjetas es menor de lo esperado',
  EXCESS_CARDS_WARNING              : 'Advertencia: El recuento de tarjetas es mayor de lo esperado',
  EXACT_COUNT_MATCH                 : '¡Perfecto! El recuento de tarjetas coincide exactamente',
  EXCESS                            : 'Exceso',
  REPRINT_HOLD_NOTICE               : 'Este trabajo se colocará en ESPERA para REIMPRIMIR',
  REPRINT_HOLD_EXPLANATION          : 'Cuando envíe este formulario, el trabajo se moverá a la razón de HOLD (reimpresión)',
  LAMINATOR_QA_CHECK                : 'Control de Calidad del Laminador',
  VALIDATING_QA_CHECK               : 'Control de Calidad de Validación',
  QUALITY_CONTROL_CHECKLIST         : 'Lista de Control de Calidad',
  CHECK_FRONT_BACK_REG              : '¿Revisaste registro de Impresión Frontal contra Impresión Trasera?',
  CHECK_CHIP_TO_IMPRESSION          : '¿Revisaste registro de Impresión contra Chip?',
  CHECK_LAMINATION_QUALITY          : '¿Revisaste la calidad del laminado?',
  CHECK_NO_AIR_BUBBLES              : '¿Revisaste que no tuviera burbujas de aire?',
  CHECK_EDGE_ALIGNMENT              : '¿Revisaste el alineamiento de los bordes?',
  CHECK_SMOOTH_EDGES                : '¿Revisaste que las tarjetas estén lisas y sin bordes rugosos o rebaba?',
  CHECK_PUNCH_ALIGNMENT             : '¿Revistaste que el ponchado esté alineado correctamente y no interfiere con la información impresa de la tarjeta?',
  ENTER_REMAINING_SETS              : 'Favor de indicar cuántos Sets faltan y deben reimprimirse. (incluyendo Scrap, Setup y los pendientes en la pantalla de la Coleadora.)',
  MISSING_SETS_WARNING              : '%0 Set(s) faltante, se necesita una reimpresión antes de pasar a la Laminadora.',
  JOB_HOLD_WARNING                  : 'Al enviar, el trabajo quedará en espera para reimpresión',
  RFID_WORK_ORDER                   : 'RFID Work Order',
  RIGHT                           : 'Derecha',
  ROLE                            : 'Papel',
  ROTATION                        : 'Rotación',
  RUN_DATE                        : 'Fecha de Ejecución',
  RUSH                            : 'Prisa',
  SAVE                            : 'Guardar',
  SAVE_UNVERIFIED_ADDRESS           : 'Guardar Domicilio Sin Verificar',
  SAVE_UNVERIFIED_ADDRESS_CONFIRM   : '¿Está seguro que quiere guardar un domicilio sin verificar?',
  SIDE_A                            : 'Frente',
  SIDE_B                            : 'Atrás',
  SCANNER_SELECTION                 : 'Seleccione un escáner',
  SCAN_CHIP_TYPE                    : 'Por favor selecciona o escanea el tipo de Chip (Requerido)',
  SCAN_AND_LOAD                   : 'Escanear y cargar',
  SCAN_ID_TITLE                     : 'Escanear la tarjeta',
  SCAN_ID_INVALID_TITLE             : 'Tarjeta de escaneo no válida',
  SCAN_ID_BODY                      : 'Todos los trabajos(páginas) y accesorios han sido escaneados. Por favor, confirme escaneando su tarjeta de identificación de empleado.',
  SCAN_ID_INVALID_BODY              : 'Por favor, asegúrese de escanear sólo su tarjeta de identificación de empleado.',
  SCRAP_MAXIMUM                   : 'No puede superar el máximo de 999',
  SCRAP_QUANTITY                  : 'Cantidad de chatarra',
  SCRAP_REPORT                    : 'Informe de Scrap',
  SCRAP_REQUIRED                  : 'Por favor, introduzca el rechazo para este batch',
  SCRAP_REASON_CODE                : 'Código de Rechazo de Scrap',
  SCRAP_REASON    : {
    LACK_PRESSURE         : 'Falta de Presion',
    DEEP_CUT              : 'Corte Profundo',
    DAMAGED_MATERIAL      : 'Material Dañado (Manejo)',
    STRIPED_MATERIAL      : 'Material Rayado (Almacen/PMG)',
    STAINED_MATERIAL      : 'Material Manchado (Manejo)',
    STAINED_MAT_WAREHOUSE : 'Material Manchado (Almacen/PMG)',
    JOB_DUPLICATE         : 'Job Duplicado',
    CURVED_MATERIAL       : 'Material Curvo',
    WRONG_DICE            : 'Dado Equivocado',
    DAMAGED               : 'Dado Dañado',
    WRONG_MATERIAL        : 'Material Equivocado',
    OTHER                 : 'Other'
  },
  SCRAP_REASON_HEADER             : 'Por favor, seleccione una razon para este rechazo',
  SCRAP_TOTALS                    : 'Introduzca los totales de rechazo (cantidad de hoja) para el batch',
  SEAL_BATCH                      : 'Selle este batch',
  SEALED                          : 'Sellado',
  SEALED_BATCH                    : 'Sellado Batch',
  SEALED_PRINTING                 : 'Impresión Sellada',
  SEARCH                          : 'Buscar',
  SERVICE                         : 'Servicio',
  SEARCH_ARCHIVE                  : 'Buscar en el archivo',
  SEARCH_JOBS_ORDER               : 'Buscar Trabajos/Órdenes...',
  SEARCH_ORDERS                   : 'Buscar Órdenes...',
  SEARCH_PRINTER                  : 'Buscar Impresoras',
  SEARCH_SHIPMENTS                : 'Buscar envíos...',
  SELECT_ALL                      : 'Seleccionar todo',
  SELECT_HORIZON                  : 'Seleccionar Horizon',
  SELECT_LASER                    : 'Seleccionar Láser',
  SELECT_HOLD_REASON              : 'Seleccione una razón de retención',
  SELECTED_JOBS                   : "Trabajos seleccionados",
  SELECTED_SETS                   : "Sets seleccionados",
  SELECTED_PRINTER                : 'Impresora seleccionada',
  SELECT_REASON                   : 'Seleccionar Razón',
  SEND                            : 'Enviar',
  SEND_AS                         : 'Enviar como %0',
  SEND_AS_NEW                     : 'Cambiar Envío a %0',
  SEND_TO_DFE                     : 'Enviar todo a DFE',
  SEND_TO_DFE_CONFIRM             : '¿Está seguro de que desea enviar todos los batches %0 al DFE? Este proceso es irreversible.',
  SEND_TO_DFE_NONE                : 'Actualmente no hay %0 batches disponibles para enviar al DFE.',
  SEND_REPRINTS_TO_DFE            : 'Enviar todos las reimpresiones a DFE',
  SERVER_ERROR                    : 'No se puede acceder al servidor. Póngase en contacto con el administrador del sistema.',
  SERVICE_TYPE                    : 'Tipo de servicio',
  SERVICE_TYPE_ADJUSTMENT_HEADER  : 'Ajuste del tipo de servicio de envío',
  SERVICE_TYPE_ADJUSTMENT_WARNING : 'Este envío no llegará al cliente a tiempo. ¿Estás seguro de que quieres enviarlo como "%0"? De lo contrario, seleccione un método diferente a continuación.',
  SERVICEOPTIONSCHARGES           : 'Opciones de servicio Tarifas',
  SET_PASSWORD                    : 'Establecer contraseña',
  SETUP_SCRAP                     : 'Scrap por Setup',
  SETTINGS                        : 'Ajustes',
  SHEET                           : 'Hoja',
  SHEET_QTY                       : 'Cantidad de hojas',
  SHEET_QTY_WARNING               : 'Advertencia: La cantidad total de hojas ({{total}}) es superior al límite máximo de 120 de la laminadora. Confirme que es correcto antes de continuar.',
  SHEET_CUT                         : 'Hojas cortadas',
  SHEET_COUNT                       : 'Conteo de Hojas',
  SHEET_COUNT_BIN                   : 'Favor de mover el Trabajo %0 a ',
  SHEET_COUNT_BODY                  : 'Por favor cuente las hojas físicas de este trabajo e ingrese la cantidad para validar.',
  SHEET_COUNT_SUCCESS               : 'Gracias. Favor de mover el Trabajo al Bin correcto.',
  SHEET_COUNT_ERROR                 : 'Número de hojas ingresadas no concuerda.',
  SHEET_COUNT_ERROR2                : 'Gracias por contar de nuevo. Cantidad de hojas sigue estando mal. Favor de oprimir en "Cantidad Incorrecta" para poner en Trabajo en Hold.',
  SHEET_COUNT_JOB_INCOMPLETE        : 'Por favor ingrese el número de hoja faltantes.',
  SHEET_INCORRECT_QTY               : 'Cantidad de hojas Incorrecta.',
  SHEET_INCORRECT_QTY_EXTRA         : '<div>%0 Hojas faltan y necesitan reimprimirse.</div><div>Favor de llenar un formato de Reimpresión y poner el Trabajo en la Estación de Reimpresiones.</div>',
  SHEET_INCORRECT_QTY_MISSING       : '<div>El Trabajo tiene %0 Hojas adicionales.</div><div>Favor de llevar el trabajo al Press Controller para su inspección.</div>',
  SHEETS_PER_PACK                 : 'Hojas por paquete',
  SHEETS                          : 'Hoja',
  INCOMPLETE_JOB                  : 'Cantidad Incorrecta',
  VALIDATING                        : 'Validando',
  VALIDATOR                         : 'Validador',
  VALIDATED                         : 'Validado',
  VALIDATION                        : 'Validación',
  SHIFT_1                         : 'Shift 1',
  SHIFT_2                         : 'Shift 2',
  SHIFT_3                         : 'Shift 3',
  SHIFTS_PLAN                     : 'Shifts Plan',
  SHIP_TO                         : 'Enviar a',
  SHIP_WITH_MAILER                : 'Menos de 26 hojas, utilice Mailer para enviar',
  SHIPMENT                        : 'Envío',
  SHIPMENT_ADDRESS_UPDATE_ERROR   : 'No pudo actualizar la dirección de envío',
  SHIPMENT_ADDRESS_UPDATED        : 'Dirección de envío actualizada',
  SHIPMENT_ADDRESS_UPDATED_INFO   : 'La dirección de envío del cliente ha sido actualizada con éxito!',
  SHIPMENT_CHARGES                : 'Gastos de envío',
  SHIPMENT_CREATED                : 'Nuevo envío creado',
  SHIPMENT_CREATED_INFO           : 'Se ha creado el envío para el pedido "%0"!',
  SHIPMENT_CREATE_ERROR_INFO      : 'Lo sentimos, algo salió mal al intentar crear un envío para el pedido %0',
  SHIPMENT_DELETED                : '',
  SHIPMENT_DELETED_INFO           : '',
  SHIPMENT_DETAILS                : 'Detalles del envío',
  SHIPMENT_ID                     : 'ID de envío',
  SHIPMENT_LABEL_ERROR            : 'Error en la etiqueta de envío',
  SHIPMENT_LABEL_ERROR_INFO       : 'No se pudo generar una etiqueta de envío para la Orden "%0". Por favor, compruebe la dirección y el número de teléfono del envío.',
  SHIPMENT_NOT_FOUND              : '¡Oops! No se ha encontrado el envío "%0".',
  SHIPMENT_NOW_READY              : 'El envío está listo',
  SHIPMENT_NOW_READY2             : 'Todos las líneas para el envío',
  SHIPMENT_NOW_READY3             : 'ya están listas para ser enviadas!',
  SHIPMENT_NOW_READY4             : 'Por favor, asegúrese de mover todos las líneas %0 (incluyendo ésta) de la Bin',
  SHIPMENT_NOW_READY4_ALT         : 'Por favor asegúrese de mover todos las %0 líneas (incluyendo ésta) a la Estación de Empaque.',
  SHIPMENT_NOW_READY5             : 'al puesto de embalaje.',
  SHIPMENT_PRICE_UPDATED          : 'Precio de envío actualizado',
  SHIPMENT_READY_PROMPT           : '¿Está listo el envío del Pedido %0 para ser enviado a la Estación de Empaque?',
  SHIPMENT_SERVICE_ADJUSTMENT     : 'El método de transporte se ha modificado de "%0" a "%1".',
  SHIPMENT_SERVICE_ADJUSTMENT_AUTO: 'El método de envío se ha cambiado automáticamente de "%0" a "%1" para cumplir con la fecha de entrega prometida.',
  SHIPMENT_TYPE                   : 'Tipo de envío',
  SHIPMENT_UPDATED                : 'Envío actualizado',
  SHIPMENT_UPDATED_INFO           : 'El envío "5" ha sido actualizado.',
  SHIPMENT_UPDATED_ERROR          : 'Error de actualización del envío',
  SHIPMENT_UPDATED_ERROR_INFO1    : 'Lo sentimos, algo salió mal al intentar actualizar el envío.',
  SHIPMENT_UPDATED_ERROR_INFO2    : 'Póngase en contacto con el responsable del sistema.',
  SHIPMENT_VOID_SUCCESS           : 'Anular Etiqueta de Envío',
  SHIPMENT_VOID_SUCCESS_INFO      : 'La etiqueta de envío ha sido anulada para la Orden %0. Asegúrese de quitar las etiquetas antigua de todos los paquetes de este envío.',
  SHIPMENT_WITH_ON_HOLD           : 'Una línea en este envío todavía está On Hold',
  SHIPMENT_ERROR_OUTSYNC          : 'El envío ya ha sido enviado. La página de Impreso puede estar desincronizada, por favor actualice el cliente.',
  SHIPMENTS                       : 'Envíos',
  SHIPMENTS_NOT_FOUND             : '¡Oops! No podía cargar ningún envío!',
  SHIPPED                         : 'Enviado',
  SHIPPED_DATE                    : 'Fecha de envío',
  SHIPPED_ORDERS                  : 'Pedidos enviados',
  SHIPPED_NEXT                    : 'Listo para enviar',
  SHIPPING                        : 'Envío',
  SHIPPING_ADDRESS_ERROR_TITLE    : 'Error de Envío',
  SHIPPING_ADDRESS_ERROR          : 'Favor de asegurarse que la dirección esté correcta y/o que el método de envío haya sido ingresado correctamente.',
  SHIPPING_ASSIGNMENT             : 'Shipping Assignment',
  SHIPPING_CONFIGURATION          : 'Configuración de Shipping',
  SHIPPING_LABEL                  : 'Etiqueta de envío',
  SHIPPING_TYPE                   : 'Tipo de envío',
  SHIPPING_STATE                  : 'Estado del envío',
  SHIPPING_METHOD                 : 'Método de envío',
  SHOW_ALL_PRINTERS               : 'Mostrar todos las Impresoras',
  SIDED_PRINT                     : 'Tipo de Impresión',
  SIGNIN_DESCRIPTION              : 'Acceda a su cuenta',
  SIGNUP                          : 'Registrarse',
  SIGNUP_INFO                     : 'Registrar una nueva cuenta para Impreso Sheets',
  SINGLE_LINE                     : 'Single Line',
  SINGLE_LINE_ORDER               : 'Single Line Order',
  SINGLES_READY                   : 'Sencillos Listos',
  SIMPLEX                         : 'Una cara',
  SIZE                            : 'Tamaño',
  SIZE_HW_DIE                     : 'Tamaño (HxW) | Matriz',
  SKU                             : 'SKU',
  SMALL_IMAGE                     : 'Imagen pequeña',
  SMARTSLITTER                    : 'SmartSlitter',
  SPECIAL_HANDLING                : 'Manipulación especial',
  SPECIAL_INK_REQUIRED            : 'Se requiere tinta especial',
  STAGING                         : 'ILS / Escenificación',
  STAGING_STATUS                  : 'ILS / Estatus Estadístico',
  START                           : 'Start',
  STATE                           : 'Estatus',
  STATION                         : 'Estación',
  STATUS                          : 'Estatus',
  START_CUTTING                   : 'Comience a corte',
  START_PRINTING                   : 'Comience a imprimir',
  STEPPED_FILE                    : 'Archivo Escalonado',
  STICKERS                        : 'Stickers',
  STOP_CUTTING                    : 'Dejar de corte',
  STORE                           : 'Tienda',
  SUBASSEMBLY                     : 'Subensamble',
  SUBASSEMBLY_PROMPT              : 'Seleccione hasta 5 subconjuntos y especifique opcionalmente el intervalo de tiempo',
  SUBMIT                          : 'Enviar',
  SUBMIT_AND_REFRESH              : 'Submit & Refresh',
  SUCCESS                         : 'Éxito',
  SUSPEND                         : 'Suspender',
  SWITCHSYSTEMFAILURE             : 'Fallo del Sistema de Cambio',
  SUPER_BIN_CONFIRM_BODY          : '¿Está seguro de mover la Orden %0 del Bin %1 a un SuperBin?',
  SUPER_BIN_CONFIRM_TITLE         : 'Mover a SuperBin',
  SUPER_BIN_SUCCESS_BODY          : 'Favor de mover la Orden %0 al ',
  SUPERVISOR                      : 'Supervisor',
  SYSTEM                          : {
    NAME   : 'Sistema',
    SETTING: {
      USER_MANAGEMENT: {
        USER_MANAGEMENT_TITLE: 'Gestión de Usuarios',
        USER_MANAGEMENT_USER_DETAILS: 'Detalles del Usuario',
        USER_MANAGEMENT_USER_GROUP_NEW_USER_EMAIL_HELP: 'Ingrese el correo electrónico del nuevo usuario que desea agregar al grupo',
        USER_MANAGEMENT_USER_GROUP_NEW_USER_EMAIL_ADD: 'Agregar Usuario',
        NO_GROUP_MEMBERSHIPS: 'no es miembro de ningún grupo',
        MEMBER_LIST: 'Lista de Miembros',
        ADD_USER_BY_EMAIL: 'Agregar Usuario por Correo Electrónico',
        USER_GROUP_MANAGE: 'Administrar Grupos de Usuarios',
        GROUP_MEMBERS: 'Miembros del Grupo',
        USER_MANAGEMENT_USER_GROUP_NEW_USER_EMAIL_REMOVE: 'Eliminar Usuario',
        NO_MEMBERS: 'No hay miembros en este grupo',
        VIEW_USER: 'Ver detalles del usuario',
        USER_MANAGEMENT_USER_DETAILS_EMAIL: 'Ingrese el correo electrónico del usuario que desea editar',
        USER_MANAGEMENT_USER_GROUP_NEW_USER_EMAIL_ADD_HELP: 'Agregar el nuevo usuario al grupo',
        USER_MANAGEMENT_USER_DELETE: 'Eliminar Usuario',
        SELECTED: 'Actual',
      },
      USER_GROUP: {
        USER_GROUP_TITLE: 'Grupo de Usuarios',
        USER_GROUP_LIST: 'Lista de Grupos de Usuarios',
        USER_GROUP_SUBHEADER: 'Los grupos de usuarios son colecciones de usuarios que comparten los mismos permisos de acceso',
        USER_GROUP_MANAGE: 'Administrar Grupos de Usuarios',
        USER: {
          CREATE: 'Crear Usuario',
          EDIT: 'Editar Usuario',
          DELETE: 'Eliminar Usuario',
          CREATE_SUCCESS: 'Usuario creado exitosamente.',
          EDIT_SUCCESS: 'Usuario actualizado exitosamente.',
          DELETE_SUCCESS: 'Usuario eliminado exitosamente.',
          SELECT_USER: 'Seleccionar Usuario',
          ADD_USER: 'Agregar Usuario',
        }
      },
      PERMISSION_GROUP: {
        HORIZON_CONFIG: {
          DESCRIPTION: 'Estos roles de usuario tienen permiso para cambiar la configuración del horizonte.',
          NAME: 'Grupo de Permisos del Horizonte'
        }
      },
      EMAIL_CHAIN: {
        EMAIL_SELECT     : 'Seleccionar un grupo de cadenas de correo',
        EMAIL_SELECT_HELP: 'Crear o eliminar un usuario existente del grupo de usuarios',
        ADMIN_EMAIL      : {
          DESCRIPTION: "Esta cadena de correos recibe correos de verificación administrativa.",
          NAME       : "Cadena de Correos Administrativos"
        },
        STUCK_BATCH_EMAIL_GROUP: {
          DESCRIPTION: "Esta cadena de correos recibe alertas sobre lotes que están atascados en el sistema.",
          NAME       : "Cadena de Correos de Batches Atascados"
        },
        DIE_TRESHOLD_EMAIL: {
          DESCRIPTION: "Esta cadena de correos recibe notificaciones sobre presiones de troquel que exceden el umbral definido.",
          NAME       : "Cadena de Correos de Umbral de Troquel"
        },
        AMAZON_DF_EOD_EMAIL_LIST: {
          DESCRIPTION: "Esta cadena de correos recibe informes de fin de día (EOD) de Amazon DF.",
          NAME       : "Cadena de Correos de Amazon DF"
        },
        EOD_SUCCESS_EMAIL: {
          DESCRIPTION: "Esta cadena de correos recibe informes de procesamiento exitoso de fin de día (EOD).",
          NAME       : "Cadena de Correos de Éxito de EoD"
        },
        EOD_STAGING_FAILURE_EMAIL: {
          DESCRIPTION: "Esta cadena de correos recibe alertas cuando falla el proceso de preparación durante el procesamiento de fin de día (EOD).",
          NAME       : "Cadena de Correos de Fallo de Preparación de EoD"
        },
        EOD_FAILURE_EMAIL: {
          DESCRIPTION: "Esta cadena de correos recibe notificaciones sobre fallos en el proceso de fin de día (EOD).",
          NAME       : "Cadena de Correos de Fallo de EoD"
        },
        LATE_ORDERS_EMAIL: {
          DESCRIPTION: "Esta cadena de correos recibe informes sobre pedidos retrasados o vencidos.",
          NAME       : "Cadena de Correos de Pedidos Retrasados"
        },
        INTOUCH_REPORT_EMAIL: {
          DESCRIPTION: "Esta cadena de correos recibe informes diarios de finalización de pedidos de Intouch al finalizar el día (EOD).",
          NAME       : "Cadena de Correos de Informes de Intouch"
        },
        ORDER_CANCEL_EMAIL_GROUP: {
          DESCRIPTION: "Esta cadena de correos recibe notificaciones sobre cancelaciones de pedidos.",
          NAME       : "Cadena de Correos de Cancelación de Pedidos"
        },
        ORDER_IMPORT_FAIL_EMAIL_GROUP: {
          DESCRIPTION: "Esta cadena de correos recibe alertas cuando fallan los procesos de importación de pedidos.",
          NAME       : "Cadena de Correos de Fallo de Importación de Pedidos"
        },
        IMPOSER_TRIGGER_FAILURE_EMAIL_GROUP: {
          DESCRIPTION: "Esta cadena de correos recibe notificaciones sobre fallos en el proceso de activación de Imposer.",
          NAME       : "Cadena de Correos de Fallo de Activación de Imposer"
        },
        THRESHOLD_EMAILS: {
          DESCRIPTION: "Esta cadena de correos recibe notificaciones relacionadas con escáneres inactivos.",
          NAME       : "Cadena de Correos de Umbral"
        },
        MISSING_PRESS_EMAIL_LIST: {
          DESCRIPTION: "Esta cadena de correos recibe alertas sobre trabajos ausentes en la prensa o trabajos impresos caducados.",
          NAME       : "Cadena de Correos de Alerta de Prensa Ausente/Trabajos Caducados"
        },
        CUSTOMER_SERVICE_REPORT_EMAIL_LIST: {
          DESCRIPTION: "Esta cadena de correos recibe informes de servicio al cliente.",
          NAME       : "Cadena de Correos de Informes de Servicio al Cliente"
        },
        KP_EMAIL_LIST: {
          DESCRIPTION: "Esta cadena de correos recibe informes de indicadores clave de rendimiento (KPI) relacionados con órdenes en espera de DPO.",
          NAME       : "Cadena de Correos de KPI"
        },
        HOLD_ORDER_EMAIL_LIST: {
          DESCRIPTION: "Esta cadena de correos recibe informes de trabajos en espera o pendientes de impresión.",
          NAME       : "Cadena de Correos de Órdenes en Espera"
        },
        NOTIFICATION_EMAIL_RECEIVERS: {
          DESCRIPTION: "Esta cadena de correos recibe alertas sobre errores en el sistema Lambda.",
          NAME       : "Cadena de Receptores de Notificaciones"
        },
        SWITCH_SYSTEM_FAILURE_EMAIL: {
          DESCRIPTION: "Esta cadena de correos recibe alertas sobre trabajos fallidos en el sistema de cambio.",
          NAME       : "Cadena de Correos de Alerta de Fallo del Sistema de Cambio"
        },
        WEEKLY_EOD_REPORT: {
          DESCRIPTION: "Esta cadena de correos recibe informes semanales de fin de día (EOD).",
          NAME       : "Cadena de Informes Semanales de EoD"
        },
        MONTHLY_DROPSHIP_CONSUMPTION_REPORT: {
          DESCRIPTION: "Esta cadena de correos recibe informes mensuales sobre el consumo de dropship.",
          NAME       : "Cadena de Informes Mensuales de Consumo de Dropship"
        },
        WEEKLY_DROPSHIP_CONSUMPTION_REPORT: {
          DESCRIPTION: "This email chain receives weekly reports on dropship consumption.",
          NAME       : "Weekly Dropship Consumption Report Chain"
        },
        PREPRESS_EMAIL_GROUP: {
          DESCRIPTION: "Esta cadena de correos recibe alertas sobre trabajos de preimpresión que se están acumulando.",
          NAME       : "Cadena de Correos de Alerta de Preimpresión"
        },
        OA_WARNING_EMAIL: {
          DESCRIPTION: "Esta cadena de correos recibe advertencias sobre grandes pedidos de clientes realizados en el sistema OA.",
          NAME       : "Cadena de Advertencias de Grandes Pedidos en OA"
        },
        SHIPMENTS_PACKAGE_REPORT: {
          DESCRIPTION: "Esta cadena de correos recibe informes sobre paquetes de envíos completados.",
          NAME       : "Cadena de Informes de Paquetes de Envíos"
        },
        SHIPPING_CHARGES: {
          DESCRIPTION: "Este grupo de usuarios tiene acceso para ver los cargos de envío en la página de detalles del pedido.",
          NAME       : "Grupo de Usuarios de Cargos de Envío"
        },
        RFID_HOTEL_EMAIL_LIST: {
          DESCRIPTION: "Esta cadena de correos recibe informes sobre paquetes de envíos completados.",
          NAME       : "Cadena de Informes de Paquetes de Envíos"
        },
        RFID_IDCBAND_EMAIL_LIST: {
          DESCRIPTION: "Esta cadena de correos recibe informes sobre paquetes de envíos completados.",
          NAME       : "Cadena de Informes de Paquetes de Envíos"
        },
        CS_ADMINS: {
          DESCRIPTION: "Administradores de Servicio al Cliente, pueden cambiar las fechas de entrega y de vencimiento de los clientes",
          NAME       : "Administradores de Servicio al Cliente"
        },
        CUT_MACHINE_CHANGE_EMAIL_LIST: {
          DESCRIPTION: "Esta cadena de correos recibe alertas sobre cambios en las asignaciones de máquinas de corte.",
          NAME       : "Cadena de Correos de Cambio de Máquina de Corte"
        },
        END_OF_MONTH_EMAIL: {
          DESCRIPTION: "Esta cadena de correos recibe informes sobre el final del mes.",
          NAME       : "Cadena de Correos de Fin de Mes"
        }
      },
      SHIPMENT_ALLOW_MP_UPGRADE: {
        DESCRIPTION: 'Permitir al sistema que actualice automáticamente el método de entrega para un envío de MarketPlace / Channel Advisor (cuando aplique)',
        NAME       : 'Habilitar Actualización de MarketPlace Shipping Speed Upgrade',
        'AMAZON' : {
          NAME: 'Amazon',
          DESCRIPTION: 'Amazon'
        },
        'GOOGLE' : {
          NAME: 'Google',
          DESCRIPTION: 'Google'
        },
        'NEWEGGB' : {
          NAME: 'NewEgg Business',
          DESCRIPTION: 'NewEgg Business'
        },
        'NEWEGGC' : {
          NAME: 'NewEgg Consumer',
          DESCRIPTION: 'NewEgg Consumer'
        },
        'WALMART' : {
          NAME: 'Walmart',
          DESCRIPTION: 'Walmart'
        },
        'STAPLES' : {
          NAME: 'Staples',
          DESCRIPTION: 'Staples Inc'
        },
        'QUILL' : {
          NAME: 'Quill',
          DESCRIPTION: 'Quill'
        },
        'OFFICEDEPOT' : {
          NAME: 'Office Depot',
          DESCRIPTION: 'Office Depot'
        },
        'MICHAELS' : {
          NAME: 'Michaels',
          DESCRIPTION: 'Michaels'
        },
        'TIKTOK' : {
          NAME: 'TikTok',
          DESCRIPTION: 'TikTok'
        },
        'ORIENTALTRADING' : {
          NAME: 'Oriental Trading Marketplace',
          DESCRIPTION: 'Oriental Trading Marketplace'
        },
        'TARGETPLUS' : {
          NAME: 'Target Plus',
          DESCRIPTION: 'Target Plus'
        },
      },
      ENABLE_SHIPPING: {
        DESCRIPTION: 'Conmutación de la disponibilidad de varios tipos de servicio de envío UPS',
        NAME       : 'Habilitar métodos de envío',
        'M4'       : {
          DESCRIPTION: 'Habilitar el envío UPS Mail Innovations',
          NAME       : 'UPS Mail Innovations'
        },
        '1DA': {
          DESCRIPTION: 'Habilitar el envío UPS Next Day Air',
          NAME       : 'UPS Next Day Air'
        },
        '1DAS': {
          DESCRIPTION: 'Habilitar el envío UPS Next Day Air (Saturday Delivery)',
          NAME       : 'UPS Next Day Air (Saturday Delivery)'
        },
        '1DM': {
          DESCRIPTION: 'Habilitar el envío UPS Next Day Air Early',
          NAME       : 'UPS Next Day Air Early'
        },
        '1DMS': {
          DESCRIPTION: 'Habilitar el envío UPS Next Day Air Early (Saturday Delivery)',
          NAME       : 'UPS Next Day Air Early (Saturday Delivery)'
        },
        '1DP': {
          DESCRIPTION: 'Habilitar el envío UPS Next Day Air Saver',
          NAME       : 'UPS Next Day Air Saver'
        },
        '2DA': {
          DESCRIPTION: 'Habilitar el envío Enable UPS 2nd Day Air',
          NAME       : 'UPS 2nd Day Air'
        },
        '2DAS': {
          DESCRIPTION: 'Habilitar el envío UPS 2nd Day Air (Saturday)',
          NAME       : 'UPS 2nd Day Air (Saturday)'
        },
        '2DM': {
          DESCRIPTION: 'Habilitar el envío Enable UPS 2nd Day Air A.M.',
          NAME       : 'UPS 2nd Day Air A.M.'
        },
        '3DS': {
          DESCRIPTION: 'Habilitar el envío Enable UPS 3 Day Select',
          NAME       : 'UPS 3 Day Select'
        },
        'GND': {
          DESCRIPTION: 'Habilitar el envío Enable UPS Ground',
          NAME       : 'UPS Ground'
        },
        '01': {
          DESCRIPTION: 'Habilitar el envío Enable UPS Worldwide Express',
          NAME       : 'UPS Worldwide Express'
        },
        '03': {
          DESCRIPTION: 'Habilitar el envío Enable UPS Standard',
          NAME       : 'UPS Standard'
        },
        '05': {
          DESCRIPTION: 'Habilitar el envío Enable UPS Worldwide Expedited',
          NAME       : 'UPS Worldwide Expedited'
        },
        '21': {
          DESCRIPTION: 'Habilitar el envío Enable UPS Worldwide Express Plus',
          NAME       : 'UPS Worldwide Express Plus'
        },
        '28': {
          DESCRIPTION: 'Habilitar el envío Enable UPS Worldwide Saver',
          NAME       : 'UPS Worldwide Saver'
        },
        '29': {
          DESCRIPTION: 'Habilitar el envío UPS Worldwide Express Freight',
          NAME       : 'UPS Worldwide Express Freight'
        },
        'FEDEX_INTERNATIONAL_PRIORITY_EXPRESS': {
          DESCRIPTION: 'Habilitar FedEx International Priority® Express',
          NAME       : 'FedEx International Priority® Express'
        },
        'INTERNATIONAL_FIRST': {
          DESCRIPTION: 'Habilitar FedEx International First®',
          NAME       : 'FedEx International First®'
        },
        'FEDEX_INTERNATIONAL_PRIORITY': {
          DESCRIPTION: 'Habilitar FedEx International Priority®',
          NAME       : 'FedEx International Priority®'
        },
        'INTERNATIONAL_ECONOMY': {
          DESCRIPTION: 'Habilitar FedEx International Economy®',
          NAME       : 'FedEx International Economy®'
        },
        'FEDEX_GROUND': {
          DESCRIPTION: 'Habilitar FedEx International Ground® y FedEx Domestic Ground®',
          NAME       : 'FedEx International Ground® y FedEx Domestic Ground®'
        },
        'FEDEX_CARGO_INTERNATIONAL_PREMIUM': {
          DESCRIPTION: 'Habilitar FedEx International Premium®',
          NAME       : 'FedEx International Premium®'
        },
        'FIRST_OVERNIGHT': {
          DESCRIPTION: 'Habilitar FedEx First Overnight®',
          NAME       : 'FedEx First Overnight®'
        },
        'FEDEX_FIRST_FREIGHT': {
          DESCRIPTION: 'Habilitar FedEx First Overnight® Freight',
          NAME       : 'FedEx First Overnight® Freight'
        },
        'FEDEX_1_DAY_FREIGHT': {
          DESCRIPTION: 'Habilitar FedEx 1Day® Freight (El servicio a Hawaii es solo desde y hacia la isla de Oahu)',
          NAME       : 'FedEx 1Day® Freight (El servicio a Hawaii es solo desde y hacia la isla de Oahu)'
        },
        'FEDEX_2_DAY_FREIGHT': {
          DESCRIPTION: 'Habilitar FedEx 2Day® Freight (El servicio a Hawaii es solo desde y hacia la isla de Oahu)',
          NAME       : 'FedEx 2Day® Freight (El servicio a Hawaii es solo desde y hacia la isla de Oahu)'
        },
        'FEDEX_3_DAY_FREIGHT': {
          DESCRIPTION: 'Habilitar FedEx 3Day® Freight (Excepto Alaska y Hawaii)',
          NAME       : 'FedEx 3Day® Freight (Excepto Alaska y Hawaii)'
        },
        'INTERNATIONAL_PRIORITY_FREIGHT': {
          DESCRIPTION: 'Habilitar FedEx International Priority® Freight',
          NAME       : 'FedEx International Priority® Freight'
        },
        'INTERNATIONAL_ECONOMY_FREIGHT': {
          DESCRIPTION: 'Habilitar FedEx International Economy® Freight',
          NAME       : 'FedEx International Economy® Freight'
        },
        'FEDEX_CARGO_AIRPORT_TO_AIRPORT': {
          DESCRIPTION: 'Habilitar FedEx International Express Freight® y FedEx International Airport-to-AirportSM',
          NAME       : 'FedEx International Express Freight® y FedEx International Airport-to-AirportSM'
        },
        'INTERNATIONAL_PRIORITY_DISTRIBUTION': {
          DESCRIPTION: 'Habilitar FedEx International Priority DirectDistribution®',
          NAME       : 'FedEx International Priority DirectDistribution®'
        },
        'FEDEX_IP_DIRECT_DISTRIBUTION_FREIGHT': {
          DESCRIPTION: 'Habilitar FedEx International Priority DirectDistribution® Freight',
          NAME       : 'FedEx International Priority DirectDistribution® Freight'
        },
        'INTL_GROUND_DISTRIBUTION': {
          DESCRIPTION: 'Habilitar International Ground® Distribution (IGD)',
          NAME       : 'International Ground® Distribution (IGD)'
        },
        'GROUND_HOME_DELIVERY': {
          DESCRIPTION: 'Habilitar FedEx Home Delivery',
          NAME       : 'FedEx Home Delivery'
        },
        'SMART_POST': {
          DESCRIPTION: 'Habilitar FedEx Ground® Economy (anteriormente conocido como FedEx SmartPost®)',
          NAME       : 'FedEx Ground® Economy (anteriormente conocido como FedEx SmartPost®)'
        },
        'PRIORITY_OVERNIGHT': {
          DESCRIPTION: 'Habilitar FedEx Priority Overnight®',
          NAME       : 'FedEx Priority Overnight®'
        },
        'STANDARD_OVERNIGHT': {
          DESCRIPTION: 'Habilitar FedEx Standard Overnight® (solo para envíos salientes de Hawaii)',
          NAME       : 'FedEx Standard Overnight® (solo para envíos salientes de Hawaii)'
        },
        'FEDEX_2_DAY': {
          DESCRIPTION: 'Habilitar FedEx 2Day® (Excepto Intra-Hawaii)',
          NAME       : 'FedEx 2Day® (Excepto Intra-Hawaii)'
        },
        'FEDEX_2_DAY_AM': {
          DESCRIPTION: 'Habilitar FedEx 2Day® AM (solo para envíos salientes de Hawaii)',
          NAME       : 'FedEx 2Day® AM (solo para envíos salientes de Hawaii)'
        },
        'FEDEX_EXPRESS_SAVER': {
          DESCRIPTION: 'Habilitar FedEx Express Saver® (Excepto Alaska y Hawaii)',
          NAME       : 'FedEx Express Saver® (Excepto Alaska y Hawaii)'
        },
        'SAME_DAY': {
          DESCRIPTION: 'Habilitar FedEx SameDay®',
          NAME       : 'FedEx SameDay®'
        },
        'SAME_DAY_CITY': {
          DESCRIPTION: 'Habilitar FedEx SameDay® City (Áreas metropolitanas seleccionadas de EE.UU.)',
          NAME       : 'FedEx SameDay® City (Áreas metropolitanas seleccionadas de EE.UU.)'
        },
        'FIRST_OVERNIGHT_SATURDAY': {
          DESCRIPTION: 'Habilitar FedEx First Overnight® (Sábado)',
          NAME       : 'FedEx First Overnight® (Sábado)'
        },
        'PRIORITY_OVERNIGHT_SATURDAY': {
          DESCRIPTION: 'Habilitar FedEx Priority Overnight® (Sábado)',
          NAME       : 'FedEx Priority Overnight® (Sábado)'
        },
        'STANDARD_OVERNIGHT_SATURDAY': {
          DESCRIPTION: 'Habilitar FedEx Standard Overnight (Sábado)',
          NAME       : 'FedEx Standard Overnight (Sábado)'
        },
        'FEDEX_2_DAY_SATURDAY': {
          DESCRIPTION: 'Habilitar FedEx 2Day® (Sábado)',
          NAME       : 'FedEx 2Day® (Sábado)'
        },
        'FEDEX_2_DAY_AM_SATURDAY': {
          DESCRIPTION: 'Habilitar FedEx 2Day® AM (Sábado - solo para envíos salientes de Hawaii)',
          NAME       : 'FedEx 2Day® AM (Sábado - solo para envíos salientes de Hawaii)'
        }
      },
      NEXT_BUSINESS_DAY: {
        DESCRIPTION: 'Establecer el siguiente día hábil para que los envíos salgan',
        NAME       : 'Siguiente día laborable'
      },
      NEXT_BUSINESS_DAY_OA: {
        DESCRIPTION: 'Establecer el siguiente día hábil para que los envíos Online Aisle salgan',
        NAME       : 'Siguiente día laborable (Online Aisle)'
      },
      NEXT_BUSINESS_DAY_RFID: {
        DESCRIPTION: 'Establecer el siguiente día hábil para que los envíos RFID salgan',
        NAME       : 'Siguiente día laborable (RFID)'
      },
      SHIPMENT_ALLOW_DOWNGRADE: {
        DESCRIPTION: 'Permitir que el sistema reduzca automáticamente el método de entrega para un transporte (cuando corresponda)',
        NAME       : 'Permitir reducción de la velocidad de envío'
      },
      SHIPMENT_ALLOW_MI_DOWNGRADE: {
        DESCRIPTION: 'Cuando esté activado, cualquier pedido entrante con envío gratuito o tarifa fija y un peso inferior a 0.8125 libras se actualizará automáticamente al tipo de servicio Mail Innovation.',
        NAME       : 'Permitir la reducción de la velocidad de envío de Mail Innovation'
      },
      LASER_SHEET_LIMIT: {
        DESCRIPTION: 'Establecer el límite del sistema de hojas para que Jobs corte con láser',
        NAME       : 'Límite de hojas para el láser'
      },
      ENABLE_EOD: {
        DESCRIPTION: 'Permitir que se procese el EoD',
        NAME       : 'Permitir EoD'
      },
      ENABLE_OA_EOD: {
        DESCRIPTION: 'Permitir que se procese el EoD de OA',
        NAME       : 'Permitir EoD de OA'
      },
      ENABLE_RFID_EOD: {
        DESCRIPTION: 'Permitir que se procese el EoD de RFID',
        NAME       : 'Permitir EoD de RFID'
      },
      ENABLE_SHEET_EOD: {
        DESCRIPTION: 'Permitir que se procese el EoD de Sheets',
        NAME       : 'Permitir EoD de Sheets'
      },
      DARK_BORDER_SCALE: {
        DESCRIPTION: 'Actualización del umbral de corte de las obras de arte oscuras en Horizon',
        NAME       : 'Umbral de la capa oscura'
      },
      LOCATION_SCANNERS: {
        DESCRIPTION: 'Si no hay resultados dentro del umbral de tiempo, el escáner se considera inactivo.',
        NAME: 'Umbral de tiempo (horas)'
      },
      ENABLE_CUTTING : {
        DESCRIPTION: 'Permitir que el sistema procese el corte desde la Página de Trabajo.',
        NAME       : 'Permitir el corte de trabajos'
      }
    },
    SETTINGS: 'Ajustes del Sistema'
  },
  SYSTEMS                     : 'Sistemas',
  TAGS                        : 'Tags',
  TAG_HOLE_PUNCHER            : 'Tag Hole Puncher',
  TARGET_PACKING_INSTRUCTIONS : 'Target+ Order - Favor de empacar orden sin Packing List',
  TARGETPLUS_ORDERS           : 'Target+ Orders',
  TARIFF_CODE                 : 'Código Arancelario',
  TEAM                        : 'Equipo',
  TEMPLATE                    : 'Plantilla',
  TEMPLATES                   : 'Plantillas',
  TEMPLATE_CLONE              : 'Plantilla de clonación',
  TEMPLATE_CLONE_INFO         : 'Introduzca un nombre para el clon de la plantilla del modelo "%0" a continuación',
  TEMPLATE_CREATE_HELP        : 'O bien, cree una nueva plantilla introduciendo un nombre de plantilla',
  TEMPLATE_MANAGER            : 'Administrador de Plantillas',
  TEMPLATE_MAPPING            : 'Mapeo de Plantillas',
  TEMPLATE_MAPPING_WARNING    : 'Este producto todavía necesita ser mapeado a una plantilla.',
  TEMPLATE_NAME               : 'Nombre de la plantilla',
  TEMPLATE_NESTED_CONFIG      : 'Template Nested Configuration',
  TEMPLATE_NEW                : 'Nueva Plantilla',
  TEMPLATE_NO_OVERLAY         : 'Esta plantilla no tiene un archivo de superposición.',
  TEMPLATE_OVERLAYS           : 'Sobreimpresiones de plantillas',
  TEMPLATE_OVERLAYS_UPDATED   : 'Los archivos de superposición se han actualizado para las siguientes plantillas:',
  TEMPLATE_RENAME             : 'Renombrar plantilla',
  TEMPLATE_RENAME_INFO        : 'Introduzca un nuevo nombre para la plantilla "%0" a continuación',
  TEMPLATE_SELECT             : 'Seleccione una plantilla',
  TEMPLATE_SELECT_HELP        : 'Modificar, clonar o eliminar una plantilla existente',
  TEMPLATES_LOST_OVERLAYS     : 'Las siguientes plantillas ya no tienen un archivo de superposición:',
  TEMPLATES_NOT_FOUND         : '¡Oops! No se pudo cargar ninguna plantilla!',
  THANK_YOU_CARD              : 'Tarjeta de agradecimiento',
  THIS_MONTH                  : 'Este mes',
  THIS_WEEK                   : 'Esta semana',
  THUMBNAIL                   : 'Miniatura',
  TICKETS                     : 'Entradas',
  TICKETS_CHECK               : 'Favor de verificar que los Tickets estén ordenados de manera secuencial. (1, 2, 3, 4, …)',
  TIMING                      : 'Timing',
  TRACKING_NUMBER             : 'Número de rastreo',
  TRACKING_NUMBER_UPDATED     : 'Número de rastreo actualizado',
  TO_ONLINE_AISLE             : 'Al Online Aisle',
  TO_ORDER                    : 'Ir a Orden',
  TO_SHEETS                   : 'Al WePrint Sheets',
  TO_RFID                     : 'Al RFID',
  TO_RFID_REPRINT             : 'Al Reprint RFID',
  TO_SHIPMENT                 : 'A Envío',
  TODAY                       : 'Hoy',
  TOMORROW                    : 'Mañana',
  TOP                         : 'Top',
  TOOLS                       : 'Herramientas',
  TOTAL                       : 'Total',
  TOTALCHARGE                 : 'Gastos totale',
  TOTAL_ITEM_COUNT            : 'Número total de artículos',
  TOTAL_JOB_COUNT             : 'Cantidad total de trabajos',
  TOTAL_QTY                   : 'Cantidad Total',
  TOTAL_SHEETS                : 'Total de hojas',
  TOTAL_SHIPMENTS             : 'Total de envíos',
  TOTAL_SHIPMENT_PRICE        : 'Precio total de envío',
  TOTAL_WEIGHT                : 'Peso Total',
  TRANSPORTATIONCHARGES       : 'Gastos de transporte',
  TRIGGERED_BY                : 'Activado por',
  TWOSIDED                    : 'Duplex',
  TWOSIDEDFLIPX               : 'Duplex',
  TYPE                        : 'Tipo',
  UPDATE                      : 'Actualizar',
  UPDATE_LTL_TRACKING_NUMBER  : 'Actualizar número de rastreo LTL',
  UPDATE_SHIPMENT_PRICE       : 'Actualizar precio de envío',
  UPDATED                     : 'Actualizado',
  UPLOAD                      : 'Subir',
  UPLOAD_FRONT                : 'Subir delantero',
  UPLOAD_BACK                 : 'Subir trasero',
  UPLOAD_ARTWORK              : 'Subir obra de arte',
  UPLOAD_FILE                 : 'Cargar archivo',
  UNCANCEL_ORDER              : 'Revertir orden',
  UNCOATED                    : 'No Recubierto ',
  UNDO_QA                     : 'Revertir QA',
  UNDO_QA_CONFIRM             : 'Por favor, introduzca una razón para deshacer (requerido):',
  UNITS                       : 'Unidades',
  UNLOCK_BATCH                : 'Desbloquear Batch',
  UNMAPPED_PRODUCTS           : 'Productos no mapeados',
  UNSAVED_CHANGES             : 'Cambios no guardados',
  UNSAVED_CHANGES_WARNING     : 'Aún tienes cambios sin guardar. ¿Desea salir de esta página y descartar sus cambios o permanecer en esta página? Haga clic en Aceptar para continuar o en Cancelar para permanecer en la página actual.',
  USAGE_STATUS                : 'Usage Status',
  USE_HOLD_BINS               : 'Mover a un Bin de Hold',
  USE_HOLD_DESC               : 'Esto asignará un BIN al Trabajo/Pedido',
  USER                        : 'Usuario',
  USER_ALREADY_EXISTS         : 'El usuario "%0" ya existe!',
  USER_CREATED                : 'Se ha creado el usuario "%0"!',
  USER_DELETED                : 'El usuario "%0" ha sido borrado!',
  USER_DETAILS                : 'Datos del usuario',
  USER_LIST                   : 'User List',
  USER_SELECT                 : 'Seleccione un Usuario',
  USER_SELECT_HELP            : 'Crear o eliminar un usuario',
  USER_UPDATED                : 'El usuario "%0" ha sido actualizado!',
  USER_VERIFIED               : 'Verificado por el usuario',
  USERS                       : 'Usuarios',
  USERNAME                    : 'Nombre de usuario',
  USERNAME_REQUIRED           : 'Se requiere nombre de usuario.',
  VALIDATE                    : 'Validar',
  VALUE                       : 'Valor',
  VERIFICATION                : 'Verificación',
  VERIFICATION_DESCRIPTION    : 'Verificación de registro de usuario',
  VERIFY_NEW_PASSWORD         : 'Verificar nueva contraseña',
  VERIFY_NEW_PASSWORD_REQUIRED: 'Vuelva a introducir su nueva contraseña.',
  VERIFYING                   : 'Por favor espere mientras verificamos la cuenta registrada...',
  VERSIONS                    : 'Versiones',
  VDP_VERSIONS                : 'VDP Versions',
  VIEW_ARTWORK                : 'View Artwork',
  VIEW_IMPOSED_FILE           : 'View Imposed File',
  VOID_SHIPMENT_LABEL         : 'Etiqueta de Envío Anulada',
  VOID_SHIPMENT               : 'Envío nulo',
  VOID_SHIPMENT_CONFIRM       : 'Por favor, introduzca un motivo de no validez.',
  WAITING                     : 'Esperando',
  WARNING                     : 'Advertencia!',
  WEIGHT                      : 'Peso',
  WHITE_LAYER                 : 'Capa blanca',
  WHITE_INK                   : 'Tinta blanca',
  WHITE_INK_CONFIRMATION      : '¡Trabajo con subimpresión blanca! Por favor, compruebe si la tinta blanca se ha aplicado correctamente.',
  WIDTH                       : 'Width',
  WORK_ORDER                  : 'Orden de trabajo',
  WORK_ORDER_PRINT            : 'Imprimir orden de trabajo',
  WORK_ORDER_PRINTED          : 'Orden de trabajo impresa',
  WORK_ORDER_PRINTED_MANUALLY : 'Orden de trabajo impresa manualmente',
  WORK_ORDER_PRINT_ERROR      : 'Error de la impresora de la orden de trabajo',
  WORKING_HOURS               : 'Working Hours',
  WORKING_ROLES               : 'Working Roles',
  WORKING_SHIFTS              : 'Working Shifts',
  YELLOWBAG                   : {
    ADD                  : 'Añadir Yellow Bag',
    BAGS                 : 'Yellow Bags',
    CONTAINS             : 'Contiene %0 pedido(s)',
    CURRENT_TOTAL        : 'Yellow Bag actual Total',
    DELETE               : 'Borrar Yellow Bag',
    DELETE_CONFIRM       : '¿Estás seguro de que quieres borrar esta Yellow Bag? Su etiqueta de envío será anulada y todos sus paquetes tendrán que ser reasignados!',
    DETAILS              : 'Detalles de la Yellow Bag',
    MAIN_INFO1           : 'Agregue aquí las Yellow Bags de UPS Mail Innovations.',
    MAIN_INFO2           : 'Todos los pedidos de UPS Mail Innovations deben asignarse a una Yellow Bag antes de ejecutar un proceso de EOD!',
    NO_OUTSTANDING       : 'No hay ningún pedido pendiente de Mail Innovations.',
    UNASSIGNED_MID_ORDERS: 'Órdenes MID sin asignar'
  },
  YES: 'Sí',
  YESTERDAY: 'Ayer',
  'KISS-CUT' : 'Kiss Cut',
  'DIE-CUT' : 'Die Cut',
  'DA270ENV25 Envelope A2' : 'DA270ENV25 Sobre A2',
  'DNBH64403 Bag & Lace' : 'DNBH64403 Bolsa y encaje',
  // 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)' : 'DKM73202 - totalQty Strings (totalQty_25 paquetes de 25)'
  'DX2820008 - totalQty Strings (totalQty_25 packs of 25)' : 'DX2820008 - totalQty Strings (totalQty_25 paquetes de 25)',
  FORM_INVALID                     : 'Formulario no válido',
  FORM_VALID                       : 'Formulario válido',
  FRAME_COUNT                      : 'Recuento de Marcos',
  FREE                             : 'Libre',
  FREE_SAMPLE                      : 'Muestra Gratuita',
  FROM                             : 'Desde',
  FULL_PRESSURE                    : 'Presión Completa',
  FUTURE_ORDERS                    : 'Pedidos Futuros',
  GEOMETRY                         : 'Geometría',
  CARRIER_CHANGE_LIMITED_CUSTOMER_ACCOUNT_LTL_AVAILABLE: 'Opciones de transportista limitadas para cuenta suministrada por el cliente - envío LTL disponible como opción alternativa',
};



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/i18n/lang_es.ts